<template>
  <div class="hyf-home">

    <!-- HEADER: el mismo del resto del sitio (logo, moneda, idioma, cuenta).
         En el centro, los enlaces y el botón propios de cada vista de la portada. -->
    <AppHeader class="home-header">
    <div class="nav-links">
      <a href="#" v-if="currentView !== 'home'" @click.prevent="setView('home')">{{ $t('homeNuevo.nav.inicio') }}</a>
      <a href="#" :class="{ current: currentView === 'partners' }" @click.prevent="setView('partners')">{{ $t('homeNuevo.nav.partners') }}</a>
      <a href="#" :class="{ current: currentView === 'universities' }" @click.prevent="setView('universities')">{{ $t('homeNuevo.nav.universidades') }}</a>
      <a href="#" :class="{ current: currentView === 'hosts' }" @click.prevent="setView('hosts')">{{ $t('homeNuevo.nav.hosts') }}</a>
    </div>
    <a v-if="currentView === 'partners'" :href="whatsappUrl" class="nav-cta" target="_blank" rel="noopener noreferrer">{{ $t('homeNuevo.nav.cta_partners') }}</a>
    <a v-else-if="currentView === 'universities'" :href="whatsappUrl" class="nav-cta" target="_blank" rel="noopener noreferrer">{{ $t('homeNuevo.nav.cta_universities') }}</a>
    <router-link v-else-if="currentView === 'hosts' && registroSameHost" :to="{ name: 'registro-alojamiento' }" class="nav-cta">{{ $t('homeNuevo.nav.cta_hosts') }}</router-link>
    <a v-else-if="currentView === 'hosts' && !registroSameHost" :href="registroAlojamientoUrl" class="nav-cta" target="_blank" rel="noopener noreferrer">{{ $t('homeNuevo.nav.cta_hosts') }}</a>
    </AppHeader>

    <!-- STICKY CTA -->
    <transition name="sticky-fade">
      <div v-if="currentView === 'home' && stickyCtaVisible" class="sticky-cta-bar">
        <router-link :to="{ name: 'formulario', query: { page: 1 } }" class="cta cta-gradient cta-recibir">{{ $t('homeNuevo.hero.cta_receive') }}</router-link>
      </div>
    </transition>

    <div v-show="currentView === 'home'">

    <!-- HERO -->
    <section class="hero-section">
      <div class="hero-bg"></div>
      <div class="hero-grid"></div>

      <div class="hero-shell">
        <div class="hero-copy reveal">
          <!-- <div class="eyebrow">
            Estudiantes internacionales primero
            <span class="dim">/ solicitudes desde todo el mundo</span>
          </div> -->

          <h1>
            {{ $t('homeNuevo.hero.title_main') }}<br/><span class="gradient-text">{{ $t('homeNuevo.hero.title_emphasis') }}</span>
          </h1>

          <p class="subhead">
            {{ $t('homeNuevo.hero.subhead') }}
          </p>

          <div class="cta-row">
            <router-link :to="{ name: 'formulario', query: { page: 1 } }" class="cta cta-gradient cta-recibir">{{ $t('homeNuevo.hero.cta_receive') }}</router-link>
            <!-- <a href="#sophi" class="cta cta-secondary">Ver cómo opera →</a> -->
          </div>

          <!-- <div class="cta-meta">
            <span class="pill live">SISTEMA ACTIVO</span>
            <span>Operación principal: Chile · España · Argentina</span>
            <span>·</span>
            <span>Solicitudes globales</span>
          </div> -->

          <!-- <div class="intake-note">
            <span>INTAKE H&amp;F · 5 PASOS</span>
            <strong>Primero completas el formulario. Después Sophi toma tu caso.</strong>
            <p>Al llegar a <code>thanks</code>, tu lead entra a la plataforma H&amp;F y recibes un WhatsApp con opciones en unos minutos.</p>
          </div> -->
        </div>

        <aside class="hero-flow-card reveal reveal-d2" aria-label="Flujo H&F">
       

          <div class="flow-track">
            <div class="flow-line"></div>
            <div class="flow-step">
              <span class="flow-index">01</span>
              <div>
                <strong>{{ $t('homeNuevo.flow.step1_title') }}</strong>
                <p>{{ $t('homeNuevo.flow.step1_body') }}</p>
              </div>
            </div>
            <div class="flow-step">
              <span class="flow-index">02</span>
              <div>
                <strong>{{ $t('homeNuevo.flow.step2_title') }}</strong>
                <p>{{ $t('homeNuevo.flow.step2_body') }}</p>
              </div>
            </div>
            <div class="flow-step">
              <span class="flow-index">03</span>
              <div>
                <strong>{{ $t('homeNuevo.flow.step3_title') }}</strong>
                <p>{{ $t('homeNuevo.flow.step3_body') }}</p>
              </div>
            </div>
            <div class="flow-step">
              <span class="flow-index">04</span>
              <div>
                <strong>{{ $t('homeNuevo.flow.step4_title') }}</strong>
                <p>{{ $t('homeNuevo.flow.step4_body') }}</p>
              </div>
            </div>
            <div class="flow-step">
              <span class="flow-index">05</span>
              <div>
                <strong>{{ $t('homeNuevo.flow.step5_title') }}</strong>
                <p>{{ $t('homeNuevo.flow.step5_body') }}</p>
              </div>
            </div>
          </div>

          <div class="flow-result">
            <span>{{ $t('homeNuevo.flow.result_label') }}</span>
            <strong>{{ $t('homeNuevo.flow.result_text') }}</strong>
          </div>
        </aside>
      </div>
           <div class="stat-row reveal reveal-d3">
          <div class="stat">
            <div class="stat-val gradient" data-count="3500" data-suffix="+">3500+</div>
            <div class="stat-lbl">{{ $t('homeNuevo.stats.intakes') }}</div>
          </div>
          <div class="stat stat-markets-hover">
            <div class="stat-val" data-count="10" :data-suffix="$t('homeNuevo.home_extra.markets_suffix')">10{{ $t('homeNuevo.home_extra.markets_suffix') }}</div>
            <!-- <div class="stat-lbl">{{ $t('homeNuevo.stats.markets') }}</div> -->
            <div class="stat-markets-list">Alemania · Austria · Holanda · Francia · Italia · Portugal · Inglaterra · España · Argentina · Chile</div>
          </div>
          <div class="stat">
            <div class="stat-val" data-count="60" data-suffix="+">60+</div>
            <div class="stat-lbl">{{ $t('homeNuevo.stats.countries') }}</div>
          </div>
          <div class="stat">
            <div class="stat-val magenta" data-count="200" data-suffix="mil+">200mil+</div>
            <div class="stat-lbl">{{ $t('homeNuevo.stats.options_first') }}</div>
          </div>
      </div>

      <!-- <div class="hero-metrics" aria-label="Métricas aproximadas H&F">
        <div>
          <strong>3</strong>
          <span>mercados principales: Chile, España y Argentina</span>
        </div>
        <div>
          <strong>100+</strong>
          <span>intakes procesados en plataforma</span>
        </div>
        <div>
          <strong>20+</strong>
          <span>países de origen de estudiantes</span>
        </div>
        <div>
          <strong>5</strong>
          <span>pasos de intake antes de Sophi</span>
        </div>
      </div> -->
    </section>

    <!-- CURATED SELECTION PROOF -->
    <section class="section selection-section reveal">
      <div class="selection-head">
        <div>
          <!-- <span class="eyebrow magenta"><span class="dim">/output</span> · selección H&amp;F</span> -->
          <h2>{{ $t('homeNuevo.selection.title_main') }} <span class="serif" style="color: var(--text-dim);">{{ $t('homeNuevo.selection.title_emphasis') }}</span></h2>
          </div>
          <p class="subhead">
            {{ $t('homeNuevo.selection.subhead') }}
          </p>
      </div>

      <div class="selection-workbench">
        <div class="lead-ops-card">
          <div class="ops-top">
            <div>
              <span class="ops-id">{{ $t('homeNuevo.ops.console.lead_prefix') }} #111</span>
              <h3>Camila</h3>
              <p>{{ $t('homeNuevo.selection.sample_profile') }}</p>
            </div>
            <div class="lead-score">
              <strong>60</strong>
              <span>{{ $t('homeNuevo.ops.console.hot') }}</span>
            </div>
          </div>

          <div class="ops-message">{{ $t('homeNuevo.ops.console.message_example') }}</div>

          <div class="score-breakdown">
            <div>
              <span>{{ $t('homeNuevo.selection.score_breakdown.tickets') }}</span>
              <strong>30/30</strong>
              <i style="--w:100%"></i>
            </div>
            <div>
              <span>{{ $t('homeNuevo.selection.score_breakdown.urgency') }}</span>
              <strong>30/30</strong>
              <i style="--w:100%"></i>
            </div>
            <div>
              <span>{{ $t('homeNuevo.selection.score_breakdown.zone') }}</span>
              <strong>0/60</strong>
              <i style="--w:8%"></i>
            </div>
          </div>

          <div class="ops-tags">
            <span>Barcelona</span>
            <span>750-800 €</span>
            <span>{{ $t('homeNuevo.home_extra.sample_type') }}</span>
            <span>Poble Sec · Gràcia · Les Corts</span>
          </div>
        </div>

        <div class="curated-options">
          <article class="stay-option">
            <div class="stay-photo" style="background-image:url('https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=900&q=80')"></div>
            <div class="stay-body">
                <div class="stay-topline">
                <span class="tier cheap">{{ $t('homeNuevo.selection.tiers.cheap') }}</span>
                <span class="verified">{{ $t('homeNuevo.selection.verified') }}</span>
              </div>
              <h3>{{ $t('homeNuevo.selection.examples.1.title') }}</h3>
              <p>{{ $t('homeNuevo.selection.examples.1.desc') }}</p>
              <div class="stay-meta">
                <span>€780{{ $t('homeNuevo.home_extra.per_month') }}</span>
                <span>18 {{ $t('homeNuevo.home_extra.min_metro') }}</span>
                <span>85/100</span>
              </div>
              <div class="tradeoff">{{ $t('homeNuevo.selection.examples.1.tradeoff') }}</div>
            </div>
          </article>

          <article class="stay-option featured">
            <div class="stay-photo" style="background-image:url('https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=900&q=80')"></div>
            <div class="stay-body">
                <div class="stay-topline">
                <span class="tier mid">{{ $t('homeNuevo.selection.tiers.mid') }}</span>
                <span class="verified">{{ $t('homeNuevo.selection.recommended') }}</span>
              </div>
              <h3>{{ $t('homeNuevo.selection.examples.2.title') }}</h3>
              <p>{{ $t('homeNuevo.selection.examples.2.desc') }}</p>
              <div class="stay-meta">
                <span>€850{{ $t('homeNuevo.home_extra.per_month') }}</span>
                <span>12 {{ $t('homeNuevo.home_extra.min_metro') }}</span>
                <span>92/100</span>
              </div>
              <div class="tradeoff">{{ $t('homeNuevo.selection.examples.2.tradeoff') }}</div>
            </div>
          </article>

          <article class="stay-option">
            <div class="stay-photo" style="background-image:url('https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=900&q=80')"></div>
            <div class="stay-body">
                <div class="stay-topline">
                <span class="tier premium">{{ $t('homeNuevo.selection.tiers.premium') }}</span>
                <span class="verified">{{ $t('homeNuevo.selection.available') }}</span>
              </div>
              <h3>{{ $t('homeNuevo.selection.examples.3.title') }}</h3>
              <p>{{ $t('homeNuevo.selection.examples.3.desc') }}</p>
              <div class="stay-meta">
                <span>€990{{ $t('homeNuevo.home_extra.per_month') }}</span>
                <span>9 {{ $t('homeNuevo.home_extra.min_bus') }}</span>
                <span>88/100</span>
              </div>
              <div class="tradeoff">{{ $t('homeNuevo.selection.examples.3.tradeoff') }}</div>
            </div>
          </article>
        </div>
      </div>

      <div class="validation-grid">
        <div class="validation-item">
          <span>01</span>
          <strong>{{ $t('homeNuevo.validation.1_title') }}</strong>
          <p>{{ $t('homeNuevo.validation.1_body') }}</p>
        </div>
        <div class="validation-item">
          <span>02</span>
          <strong>{{ $t('homeNuevo.validation.2_title') }}</strong>
          <p>{{ $t('homeNuevo.validation.2_body') }}</p>
        </div>
        <div class="validation-item">
          <span>03</span>
          <strong>{{ $t('homeNuevo.validation.3_title') }}</strong>
          <p>{{ $t('homeNuevo.validation.3_body') }}</p>
        </div>
      </div>

      <!-- <div class="housing-types">
        <span>Tipos que podemos considerar</span>
        <strong>Compartido · Entero · Privado</strong>
        <p>Habitación privada, departamento compartido, monambiente, departamento entero, coliving, residencia estudiantil y opciones privadas según ciudad, presupuesto y disponibilidad.</p>
      </div> -->
    </section>

    <div class="section-divider"></div>

    <!-- ═══════ SOPHI LIVE DASHBOARD ═══════ -->
    <section class="section reveal" id="sophi" style="padding-top: 48px;">
      <!-- <div class="system-meta">
        <span class="eyebrow magenta" style="margin-bottom: 0;">/system · sophi engine</span>
        <span class="pill magenta">AI + HUMAN-IN-THE-LOOP</span>
      </div> -->

      <h2>{{ $t('homeNuevo.sophi.title_main') }}<br/><span class="serif" style="color: var(--text-dim);">{{ $t('homeNuevo.sophi.title_emphasis') }}</span></h2>
      <p class="subhead">
        {{ $t('homeNuevo.sophi.subhead') }}
      </p>

      <div class="pv-grid">
        <div class="pv-card">
          <span>{{ $t('homeNuevo.sophi.card1_title') }}</span>
          <strong>{{ $t('homeNuevo.sophi.card1_strong') }}</strong>
          <p>{{ $t('homeNuevo.sophi.card1_body') }}</p>
        </div>
        <div class="pv-card">
          <span>{{ $t('homeNuevo.sophi.card2_title') }}</span>
          <strong>{{ $t('homeNuevo.sophi.card2_strong') }}</strong>
          <p>{{ $t('homeNuevo.sophi.card2_body') }}</p>
        </div>
        <div class="pv-card">
          <span>{{ $t('homeNuevo.sophi.card3_title') }}</span>
          <strong>{{ $t('homeNuevo.sophi.card3_strong') }}</strong>
          <p>{{ $t('homeNuevo.sophi.card3_body') }}</p>
        </div>
      </div>

    
    </section>

    <div class="section-divider"></div>

    <!-- HOW IT WORKS -->
    <section class="section reveal" id="how">
      <!-- <span class="eyebrow"><span class="dim">/section_01</span> · cómo funciona</span> -->
      <h2>{{ $t('homeNuevo.how.title_main') }} <span class="serif" style="color: var(--text-dim);">{{ $t('homeNuevo.how.title_emphasis') }}</span></h2>
      <p class="subhead">{{ $t('homeNuevo.how.subhead') }}</p>

      <div class="steps-grid">

        <div class="step-item">
          <div class="step-num">{{ $t('homeNuevo.home_extra.how_num1') }}</div>
          <div><div class="step-title">{{ $t('homeNuevo.how.steps.1_title') }}</div></div>
          <div class="step-body">{{ $t('homeNuevo.how.steps.1_body') }}</div>
        </div>

        <div class="step-item">
          <div class="step-num">{{ $t('homeNuevo.home_extra.how_num2') }}</div>
          <div><div class="step-title">{{ $t('homeNuevo.how.steps.2_title') }}</div></div>
          <div class="step-body">{{ $t('homeNuevo.how.steps.2_body') }}</div>
        </div>

        <div class="step-item">
          <div class="step-num">{{ $t('homeNuevo.home_extra.how_num3') }}</div>
          <div><div class="step-title">{{ $t('homeNuevo.how.steps.3_title') }}</div></div>
          <div class="step-body">{{ $t('homeNuevo.how.steps.3_body') }}</div>
        </div>

        <div class="step-item">
          <div class="step-num">{{ $t('homeNuevo.home_extra.how_num4') }}</div>
          <div><div class="step-title">{{ $t('homeNuevo.how.steps.4_title') }}</div></div>
          <div class="step-body">{{ $t('homeNuevo.how.steps.4_body') }}</div>
        </div>

        <div class="step-item">
          <div class="step-num">{{ $t('homeNuevo.home_extra.how_num5') }}</div>
          <div><div class="step-title">{{ $t('homeNuevo.how.steps.5_title') }}</div></div>
          <div class="step-body">{{ $t('homeNuevo.how.steps.5_body') }}</div>
        </div>

      </div>
    </section>

    <div class="section-divider"></div>

    <!-- AFTER INTAKE OPERATING LOOP -->
    <section class="section ops-loop-section reveal">
      <div class="ops-loop-head">
        <h2>{{ $t('homeNuevo.ops.title_main') }} <span class="serif" style="color: var(--text-dim);">{{ $t('homeNuevo.ops.title_emphasis') }}</span></h2>
        <p class="subhead">{{ $t('homeNuevo.ops.subhead') }}</p>
      </div>

      <div class="ops-loop-grid">
        <div class="ops-console">
          <div class="console-top">
            <div>
              <strong>{{ $t('homeNuevo.ops.console.intakes_label') }}</strong>
              <span>{{ $t('homeNuevo.ops.console.panel_label') }}</span>
            </div>
            <span class="console-count">114</span>
          </div>

          <div class="console-row hot">
            <span>#114</span>
            <strong>{{ $t('homeNuevo.home_extra.console_row1') }}</strong>
            <em>Buenos Aires</em>
            <b>100 {{ $t('homeNuevo.ops.console.hot') }}</b>
          </div>
          <div class="console-row">
            <span>#111</span>
            <strong>{{ $t('homeNuevo.home_extra.console_row2') }}</strong>
            <em>Barcelona</em>
            <b>100 {{ $t('homeNuevo.ops.console.hot') }}</b>
          </div>
          <div class="console-row">
            <span>#108</span>
            <strong>{{ $t('homeNuevo.home_extra.console_row3') }}</strong>
            <em>Barcelona</em>
            <b>90 {{ $t('homeNuevo.ops.console.cool') }}</b>
          </div>

          <div class="console-detail">
            <div>
              <span>{{ $t('homeNuevo.ops.console.message_label') }}</span>
              <p>"{{ $t('homeNuevo.home_extra.console_detail_message') }}"</p>
            </div>
            <div class="console-score">
              <strong>90/100</strong>
              <span>{{ $t('homeNuevo.ops.console.hot_match') }}</span>
            </div>
          </div>
        </div>

        <div class="loop-steps">
          <div class="loop-step">
            <span>01</span>
            <strong>{{ $t('homeNuevo.ops.loop.1_title') }}</strong>
            <p>{{ $t('homeNuevo.ops.loop.1_body') }}</p>
          </div>
          <div class="loop-step">
            <span>02</span>
            <strong>{{ $t('homeNuevo.ops.loop.2_title') }}</strong>
            <p>{{ $t('homeNuevo.ops.loop.2_body') }}</p>
          </div>
          <div class="loop-step">
            <span>03</span>
            <strong>{{ $t('homeNuevo.ops.loop.3_title') }}</strong>
            <p>{{ $t('homeNuevo.ops.loop.3_body') }}</p>
          </div>
          <div class="loop-step">
            <span>04</span>
            <strong>{{ $t('homeNuevo.ops.loop.4_title') }}</strong>
            <p>{{ $t('homeNuevo.ops.loop.4_body') }}</p>
          </div>
          <div class="loop-step">
            <span>05</span>
            <strong>{{ $t('homeNuevo.ops.loop.5_title') }}</strong>
            <p>{{ $t('homeNuevo.ops.loop.5_body') }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="section-divider"></div>

    <!-- TRUST / OBJECTIONS -->
    <section class="section trust-section reveal">
      <!-- <span class="eyebrow magenta"><span class="dim">/confianza</span> · dudas que resolvemos</span> -->
      <h2>{{ $t('homeNuevo.trust.title_main') }} <span class="serif" style="color: var(--text-dim);">{{ $t('homeNuevo.trust.title_emphasis') }}</span></h2>
      <p class="subhead">{{ $t('homeNuevo.trust.subhead') }}</p>

      <div class="trust-grid">
        <div class="trust-card">
          <span>{{ $t('homeNuevo.trust.cards.1.label') }}</span>
          <strong>{{ $t('homeNuevo.trust.cards.1.title') }}</strong>
          <p>{{ $t('homeNuevo.trust.cards.1.body') }}</p>
        </div>
        <div class="trust-card">
          <span>{{ $t('homeNuevo.trust.cards.2.label') }}</span>
          <strong>{{ $t('homeNuevo.trust.cards.2.title') }}</strong>
          <p>{{ $t('homeNuevo.trust.cards.2.body') }}</p>
        </div>
        <div class="trust-card">
          <span>{{ $t('homeNuevo.trust.cards.3.label') }}</span>
          <strong>{{ $t('homeNuevo.trust.cards.3.title') }}</strong>
          <p>{{ $t('homeNuevo.trust.cards.3.body') }}</p>
        </div>
        <div class="trust-card">
          <span>{{ $t('homeNuevo.trust.cards.4.label') }}</span>
          <strong>{{ $t('homeNuevo.trust.cards.4.title') }}</strong>
          <p>{{ $t('homeNuevo.trust.cards.4.body') }}</p>
        </div>
        <div class="trust-card">
          <span>{{ $t('homeNuevo.trust.cards.5.label') }}</span>
          <strong>{{ $t('homeNuevo.trust.cards.5.title') }}</strong>
          <p>{{ $t('homeNuevo.trust.cards.5.body') }}</p>
        </div>
        <div class="trust-card">
          <span>{{ $t('homeNuevo.trust.cards.6.label') }}</span>
          <strong>{{ $t('homeNuevo.trust.cards.6.title') }}</strong>
          <p>{{ $t('homeNuevo.trust.cards.6.body') }}</p>
        </div>
      </div>

      <!-- <div class="limits-note">
        <strong>Transparencia importante:</strong>
        <p>H&amp;F acompaña el proceso, ayuda a entender condiciones y coordina el avance, pero no gestiona ni firma contratos. El contrato es entre anfitrión y huésped.</p>
      </div> -->
    </section>

    <div class="section-divider"></div>

    <!-- WHY WE EXIST -->
    <!-- <section class="section">
      <span class="eyebrow magenta"><span class="dim">/section_02</span> · por qué existimos</span>
      <h2>Mudarse de país no es <span class="serif" style="color: var(--text-dim);">comprar un vuelo.</span></h2>
      <p class="subhead">Los portales tradicionales te tratan como si lo fuera. Estas son las cinco cosas que rompen ese supuesto.</p>

      <div class="problem-grid">
        <div class="problem-card">
          <div class="num">/01</div>
          <div class="title">Muchos anuncios no están realmente disponibles</div>
          <div class="body">Anuncios viejos, calendarios desactualizados, "ya se reservó pero te ofrezco otro". El usuario internacional lo descubre tarde, desde la mitad del mundo.</div>
        </div>
        <div class="problem-card">
          <div class="num">/02</div>
          <div class="title">Las estafas existen y son sistemáticas</div>
          <div class="body">Anuncios falsos, depósitos a cuentas que desaparecen, identidades clonadas. Quien paga desde afuera es el target perfecto.</div>
        </div>
        <div class="problem-card">
          <div class="num">/03</div>
          <div class="title">Llegar sin alojamiento resuelto es caro</div>
          <div class="body">Hostel a 80 €/noche, dos semanas perdidas visitando propiedades, decisiones apuradas que después se lamentan. El costo oculto de "lo veo cuando llegue".</div>
        </div>
        <div class="problem-card">
          <div class="num">/04</div>
          <div class="title">El idioma es una barrera más grande de lo que parece</div>
          <div class="body">Contratos en idioma local, garantías que no entiendes, expectativas culturales sobre depósitos y plazos. Los portales no traducen el contexto, solo las palabras.</div>
        </div>
        <div class="problem-card">
          <div class="num">/05</div>
          <div class="title">No hay nadie del otro lado</div>
          <div class="body">Cuando el portal falla, ¿con quién hablas? Email genérico, respuesta en 5 días, problema sin resolver. H&amp;F tiene un humano coordinando tu caso desde el inicio.</div>
        </div>
      </div>
    </section> -->

    <div class="section-divider"></div>

    <!-- SOCIAL PROOF -->
    <section class="section reveal" id="social-proof">
      <!-- <span class="eyebrow"><span class="dim">/section_03</span> · operación y casos</span> -->
      <h2>{{ $t('homeNuevo.social.title_main') }} <span class="serif" style="color: var(--text-dim);">{{ $t('homeNuevo.social.title_emphasis') }}</span></h2>
      <p class="subhead">{{ $t('homeNuevo.social.subhead') }}</p>

      <div class="testimonial-grid">
        <div class="testimonial">
          <div class="testimonial-quote">{{ $t('homeNuevo.social.testimonials.1.quote') }}</div>
          <div class="testimonial-meta"><strong>{{ $t('homeNuevo.social.testimonials.1.meta_title') }}</strong>{{ $t('homeNuevo.social.testimonials.1.meta') }}</div>
        </div>
        <div class="testimonial">
          <div class="testimonial-quote">{{ $t('homeNuevo.social.testimonials.2.quote') }}</div>
          <div class="testimonial-meta"><strong>{{ $t('homeNuevo.social.testimonials.2.meta_title') }}</strong>{{ $t('homeNuevo.social.testimonials.2.meta') }}</div>
        </div>
        <div class="testimonial">
          <div class="testimonial-quote">{{ $t('homeNuevo.social.testimonials.3.quote') }}</div>
          <div class="testimonial-meta"><strong>{{ $t('homeNuevo.social.testimonials.3.meta_title') }}</strong>{{ $t('homeNuevo.social.testimonials.3.meta') }}</div>
        </div>
      </div>

      <!-- <div class="stat-row"> -->
        <!-- <div class="stat">
          <div class="stat-val gradient">100+</div>
          <div class="stat-lbl">Intakes procesados</div>
        </div> -->
        <!-- <div class="stat">
          <div class="stat-val">3 mercados</div>
          <div class="stat-lbl">Chile · España · Argentina</div>
        </div> -->
        <!-- <div class="stat">
          <div class="stat-val">20+</div>
          <div class="stat-lbl">Países de origen</div>
        </div> -->
        <!-- <div class="stat">
          <div class="stat-val magenta">3</div>
          <div class="stat-lbl">Opciones por primera selección</div>
        </div> -->
      <!-- </div> -->
    </section>

    <!-- FINAL CTA-->
    <section class="section" id="cta">
      <div class="final-cta-block final-cta-home">
        <div class="h">{{ $t('homeNuevo.finalCta.title_main') }}<br/><em>{{ $t('homeNuevo.finalCta.title_emphasis') }}</em></div>
        <p class="sub">{{ $t('homeNuevo.finalCta.subhead') }}</p>
        <router-link :to="{ name: 'formulario', query: { page: 1 } }" class="cta cta-primary cta-recibir"><span>{{ $t('homeNuevo.finalCta.cta_receive') }}</span></router-link>
        <div class="cta-meta">
          <span class="pill live">{{ $t('homeNuevo.finalCta.pill_live') }}</span>
          <span>{{ $t('homeNuevo.finalCta.coverage') }}</span>
          <span>·</span>
          <span>{{ $t('homeNuevo.finalCta.no_cost') }}</span>
        </div>
      </div>
    </section> 

    </div><!-- END HOME VIEW -->

    <!-- ═══════════════════════════════════════════════════════ PARTNERS VIEW -->
    <div v-show="currentView === 'partners'" data-view="partners">

      <section class="hero-section">
        <div class="hero-bg"></div>
        <div class="hero-grid"></div>
      
        <h1 class="reveal">{{ $t('homeNuevo.partners.hero_title') }}<br/><span class="gradient-text">{{ $t('homeNuevo.partners.hero_emphasis') }}</span></h1>
          <p class="subhead reveal reveal-d1">{{ $t('homeNuevo.partners.hero_subhead') }}</p>
          <div class="cta-row reveal reveal-d2">
            <a :href="whatsappUrl" class="cta cta-gradient" target="_blank" rel="noopener noreferrer">{{ $t('homeNuevo.partners.cta') }}</a>
          </div>
        <div class="stat-row reveal reveal-d3" style="margin-top: 56px;">
          <div class="stat"><div class="stat-val">0</div><div class="stat-lbl">{{ $t('homeNuevo.partners.stats.cost_fixed') }}</div></div>
          <div class="stat"><div class="stat-val"><span data-count="30">30</span><span style="font-size:24px;color:var(--text-dim);">min</span></div><div class="stat-lbl">{{ $t('homeNuevo.partners.stats.sla') }}</div></div>
          <div class="stat"><div class="stat-val"><span data-count="100">100</span><span style="font-size:24px;color:var(--text-dim);">%</span></div><div class="stat-lbl">{{ $t('homeNuevo.partners.stats.closing_control') }}</div></div>
          <div class="stat"><div class="stat-val gradient">{{ $t('homeNuevo.partners.stats.custom_management') }}</div></div>
        </div>
      </section>

      <!-- <section class="section" style="padding-top: 56px;">
        <div class="system-meta">
         
          
        </div>
        <h2>El lead llega a tu agente<br/><span class="serif" style="color: var(--text-dim);">listo para cerrar.</span></h2>
        <p class="subhead">Cuando Sophi termina la calificación y valida disponibilidad contra tu iCal, tu agente recibe esto. Cero ruido, cero leads fríos, cero propiedades ocupadas.</p>
        <div class="live-system">
          <div class="product-stage">
            <div class="app-frame">
              <div class="app-titlebar">
                <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span>
                <span class="app-path"><span class="seg">partner /</span> <span class="current">paso_queue</span></span>
                <span class="app-status">LIVE · 1 nuevo</span>
              </div>
              <div class="dash-grid">
                <div class="dash-panel">
                  <div class="panel-head">
                    <div class="panel-title"><span style="width:8px;height:8px;border-radius:50%;background:var(--orange);display:inline-block;"></span> Ficha del lead</div>
                    <span class="panel-title-meta">case_8f3a2b</span>
                  </div>
                  <div style="display:grid;grid-template-columns:auto 1fr;gap:10px 16px;font-size:13px;">
                    <span style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;padding-top:2px;">Persona</span><span style="color:var(--text-light);">Camila R. · 28 · 🇨🇱 Chile</span>
                    <span style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;padding-top:2px;">Destino</span><span style="color:var(--text-light);">Barcelona · Les Corts</span>
                    <span style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;padding-top:2px;">Fechas</span><span style="color:var(--text-light);">01/09/2026 → 31/07/2027</span>
                    <span style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;padding-top:2px;">Duración</span><span style="color:var(--text-light);">11 meses · mid-term</span>
                    <span style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;padding-top:2px;">Presupuesto</span><span style="color:var(--text-light);">€1.100/mes · confirmado</span>
                    <span style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;padding-top:2px;">Perfil</span><span style="color:var(--text-light);">MBA IESE · admisión confirmada</span>
                    <span style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;padding-top:2px;">Docs</span><span style="color:var(--text-light);">Pasaporte · carta admisión · fondos</span>
                    <span style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;padding-top:2px;">Propiedad</span><span style="color:var(--orange-bright);">Estudio Les Corts · €980/mes</span>
                  </div>
                  <div style="margin-top:20px;padding:12px 14px;background:rgba(252,112,16,0.10);border:0.5px solid rgba(252,112,16,0.25);border-radius:10px;">
                    <div style="font-family:var(--hyf-mono);font-size:9px;color:var(--orange-bright);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:4px;">Pre-aceptación</div>
                    <div style="font-size:12px;color:var(--text-light-dim);line-height:1.5;">Cumple el 100% de los criterios firmados. <span style="color:var(--text-light);">Aceptación automática habilitada.</span></div>
                  </div>
                </div>
                <div class="dash-panel">
                  <div class="panel-head">
                    <div class="panel-title">SLA tracker</div>
                    <span class="panel-actions">paso @ 14:05</span>
                  </div>
                  <div style="display:flex;align-items:center;gap:16px;margin-bottom:24px;">
                    <div style="font-family:var(--hyf-display);font-size:48px;font-weight:300;color:var(--orange-bright);letter-spacing:-0.04em;">08:24</div>
                    <div>
                      <div style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;">restante del SLA</div>
                      <div style="font-size:12px;color:var(--text-light-dim);margin-top:2px;">límite: 30 min · agente notificado</div>
                    </div>
                  </div>
                  <div class="event-log">
                    <div class="event"><span class="event-time">14:05</span><span class="event-type ok">dispatch</span><span class="event-msg">WhatsApp + email al agente</span></div>
                    <div class="event"><span class="event-time">14:05</span><span class="event-type">queued</span><span class="event-msg">case_8f3a2b en cola del partner</span></div>
                    <div class="event"><span class="event-time">14:06</span><span class="event-type ok">ack</span><span class="event-msg">agente confirmó recepción</span></div>
                    <div class="event"><span class="event-time">14:07</span><span class="event-type">contact</span><span class="event-msg">agente <span class="hl">contactó al usuario</span></span></div>
                    <div class="event"><span class="event-time">--:--</span><span class="event-type" style="color:var(--text-light-faint);">pending</span><span class="event-msg" style="color:var(--text-light-faint);">esperando confirmación de cierre</span></div>
                  </div>
                  <div style="margin-top:24px;padding:14px;background:var(--bg-deep-3);border:0.5px solid var(--border-dark-2);border-radius:10px;">
                    <div style="font-family:var(--hyf-mono);font-size:9px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:8px;">Status del partner · últimos 30d</div>
                    <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px;">
                      <div><div style="font-family:var(--hyf-display);font-size:20px;color:var(--text-light);font-weight:500;">98%</div><div style="font-size:10px;color:var(--text-light-faint);font-family:var(--hyf-mono);">SLA cumplido</div></div>
                      <div><div style="font-family:var(--hyf-display);font-size:20px;color:#10B981;font-weight:500;">0</div><div style="font-size:10px;color:var(--text-light-faint);font-family:var(--hyf-mono);">strikes</div></div>
                      <div><div style="font-family:var(--hyf-display);font-size:20px;color:var(--text-light);font-weight:500;">12 min</div><div style="font-size:10px;color:var(--text-light-faint);font-family:var(--hyf-mono);">contacto prom.</div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> -->

      <!-- <div class="section-divider"></div> -->

      

      <section class="section reveal">
        <!-- <span class="eyebrow"><span class="dim">/section_02</span> · por qué este modelo</span> -->
        <h2>{{ $t('homeNuevo.partners_features.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.partners_features.title_emphasis') }}</span></h2>
        <p class="subhead">{{ $t('homeNuevo.partners_features.subhead') }}</p>
        <div class="features-grid">
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.partners_features.1.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.partners_features.1.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.partners_features.1.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.partners_features.2.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.partners_features.2.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.partners_features.2.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.partners_features.3.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.partners_features.3.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.partners_features.3.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.partners_features.4.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.partners_features.4.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.partners_features.4.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.partners_features.5.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.partners_features.5.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.partners_features.5.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.partners_features.6.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.partners_features.6.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.partners_features.6.desc') }}</div>
          </div>
        </div>
      </section>

      <div class="section-divider"></div>

      <section class="section-narrow reveal">
        <!-- <span class="eyebrow"><span class="dim">/section_03</span> · economics</span> -->
        <h2>{{ $t('homeNuevo.partners_economics.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.partners_economics.title_emphasis') }}</span></h2>
        <div style="margin-top: 48px; border-top: 0.5px solid var(--border);">
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;border-bottom:0.5px solid var(--border);"><div class="eyebrow-light">{{ $t('homeNuevo.partners_economics.rows.1.label') }}</div><div class="body"><strong>{{ $t('homeNuevo.partners_economics.rows.1.body_strong') }}</strong> · {{ $t('homeNuevo.partners_economics.rows.1.body') }}</div></div>
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;border-bottom:0.5px solid var(--border);"><div class="eyebrow-light">{{ $t('homeNuevo.partners_economics.rows.2.label') }}</div><div class="body">{{ $t('homeNuevo.partners_economics.rows.2.body') }}</div></div>
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;border-bottom:0.5px solid var(--border);"><div class="eyebrow-light">{{ $t('homeNuevo.partners_economics.rows.3.label') }}</div><div class="body">{{ $t('homeNuevo.partners_economics.rows.3.body') }}</div></div>
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;border-bottom:0.5px solid var(--border);"><div class="eyebrow-light">{{ $t('homeNuevo.partners_economics.rows.4.label') }}</div><div class="body">{{ $t('homeNuevo.partners_economics.rows.4.body') }}</div></div>
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;"><div class="eyebrow-light">{{ $t('homeNuevo.partners_economics.rows.5.label') }}</div><div class="body">{{ $t('homeNuevo.partners_economics.rows.5.body') }}</div></div>
        </div>
        <!-- <div style="margin-top:48px;padding:24px;background:var(--orange-soft);border-radius:12px;border:0.5px solid var(--orange-line);">
          <div class="eyebrow-light" style="color:var(--orange-text);margin-bottom:8px;">Gestión a medida</div>
          <div class="body">Las condiciones de gestión se acuerdan a medida con cada partner.</div>
        </div> -->
      </section>

      <section class="section reveal" id="partners-how">
        <!-- <span class="eyebrow"><span class="dim">/section_01</span> · cómo opera el modelo</span> -->
        <h2>{{ $t('homeNuevo.partners_how.title_main') }} <span class="serif">{{ $t('homeNuevo.partners_how.title_emphasis') }}</span></h2>
        <p class="subhead">{{ $t('homeNuevo.partners_how.subhead') }}</p>
        <div class="steps-grid">
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.partners_how.steps.1.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.partners_how.steps.1.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.partners_how.steps.1.body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.partners_how.steps.2.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.partners_how.steps.2.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.partners_how.steps.2.body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.partners_how.steps.3.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.partners_how.steps.3.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.partners_how.steps.3.body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.partners_how.steps.4.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.partners_how.steps.4.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.partners_how.steps.4.body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.partners_how.steps.5.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.partners_how.steps.5.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.partners_how.steps.5.body') }}</div>
          </div>
        </div>
      </section>

      <div class="section-divider"></div>

      <section class="section reveal">
        <!-- <span class="eyebrow"><span class="dim">/section_04</span> · lo que necesitamos de tu lado</span> -->
        <h2>{{ $t('homeNuevo.partners_requirements_title.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.partners_requirements_title.title_emphasis') }}</span></h2>
        <div style="margin-top:48px;display:grid;grid-template-columns:1fr 1fr;gap:16px;">
          <div class="problem-card" style="background:var(--bg);"><div class="num">/01</div><div class="title">{{ $t('homeNuevo.partners_requirements.1.title') }}</div><div class="body">{{ $t('homeNuevo.partners_requirements.1.body') }}</div></div>
          <div class="problem-card" style="background:var(--bg);"><div class="num">/02</div><div class="title">{{ $t('homeNuevo.partners_requirements.2.title') }}</div><div class="body">{{ $t('homeNuevo.partners_requirements.2.body') }}</div></div>
          <div class="problem-card" style="background:var(--bg);"><div class="num">/03</div><div class="title">{{ $t('homeNuevo.partners_requirements.3.title') }}</div><div class="body">{{ $t('homeNuevo.partners_requirements.3.body') }}</div></div>
          <div class="problem-card" style="background:var(--bg);"><div class="num">/04</div><div class="title">{{ $t('homeNuevo.partners_requirements.4.title') }}</div><div class="body">{{ $t('homeNuevo.partners_requirements.4.body') }}</div></div>
          <div class="problem-card" style="background:var(--bg);grid-column:span 2;"><div class="num">/05</div><div class="title">{{ $t('homeNuevo.partners_requirements.5.title') }}</div><div class="body">{{ $t('homeNuevo.partners_requirements.5.body') }}</div></div>
        </div>
      </section>

      <section class="section reveal">
        <div class="final-cta-block">
          <div class="h">{{ $t('homeNuevo.partners_final.title_main') }}<br/><em>{{ $t('homeNuevo.partners_final.title_emphasis') }}</em></div>
          <p class="sub">{{ $t('homeNuevo.partners_final.subhead') }}</p>
          <a :href="whatsappUrl" class="cta cta-primary" target="_blank" rel="noopener noreferrer">{{ $t('homeNuevo.partners_final.cta') }}</a>
          <div class="cta-meta">
            <span>{{ $t('homeNuevo.partners_final.email') }}</span><span> · </span><span>{{ $t('homeNuevo.partners_final.response_time') }}</span><span> · </span><span>{{ $t('homeNuevo.partners_final.call') }}</span>
          </div>
        </div>
      </section>

    </div><!-- END PARTNERS VIEW -->

    <!-- ═══════════════════════════════════════════════ UNIVERSITIES VIEW -->
    <div v-show="currentView === 'universities'" data-view="universities">

      <section class="hero-section">
        <div class="hero-bg"></div>
        <div class="hero-grid"></div>
        <!-- <div class="eyebrow"><span class="dim">/ universities /</span> partnership</div> -->
        <h1 class="reveal">{{ $t('homeNuevo.universities.hero_title') }}<br/><span class="gradient-text">{{ $t('homeNuevo.universities.hero_emphasis') }}</span></h1>
        <p class="subhead reveal reveal-d1">{{ $t('homeNuevo.universities.hero_subhead') }}</p>
        <div class="cta-row reveal reveal-d2">
          <a :href="whatsappUrl" class="cta cta-gradient" target="_blank" rel="noopener noreferrer">{{ $t('homeNuevo.universities.cta') }}</a>
        </div>
        <div class="stat-row reveal reveal-d3" style="margin-top: 56px;">
          <div class="stat"><div class="stat-val">0</div><div class="stat-lbl">{{ $t('homeNuevo.universities.stats.operational_load') }}</div></div>
          <div class="stat"><div class="stat-val">3-12<span style="font-size:24px;color:var(--text-dim);">m</span></div><div class="stat-lbl">{{ $t('homeNuevo.universities.stats.mid_term_stays') }}</div></div>
          <div class="stat"><div class="stat-val">2-way</div><div class="stat-lbl">{{ $t('homeNuevo.universities.stats.entries_exits') }}</div></div>
          <div class="stat"><div class="stat-val gradient"><span data-count="100">100</span><span style="font-size:24px;">%</span></div><div class="stat-lbl">{{ $t('homeNuevo.universities.stats.human_support') }}</div></div>
        </div>
      </section>

      <!-- <section class="section" style="padding-top: 56px;">
        <div class="system-meta">
          <span class="eyebrow magenta" style="margin-bottom: 0;">/system · cohort coverage</span>
          <span class="pill magenta">REAL-TIME · COHORT</span>
        </div>
        <h2>Cada estudiante,<br/><span class="serif" style="color:var(--text-dim);">trackeado hasta el cierre.</span></h2>
        <p class="subhead">Tu oficina internacional ve en tiempo real qué estudiantes están en proceso, cuáles ya cerraron, y dónde hay que intervenir. Cero hojas de cálculo.</p>
        <div class="live-system">
          <div class="product-stage">
            <div class="app-frame">
              <div class="app-titlebar">
                <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span>
                <span class="app-path"><span class="seg">university /</span> <span class="current">cohort_fall_2026</span></span>
                <span class="app-status">LIVE · 47 activos</span>
              </div>
              <div class="dash-grid">
                <div class="dash-panel">
                  <div class="panel-head">
                    <div class="panel-title"><span style="width:8px;height:8px;border-radius:50%;background:var(--magenta);display:inline-block;"></span> Cohorte · Fall 2026</div>
                    <span class="panel-title-meta">MBA + postgrado</span>
                  </div>
                  <div style="display:flex;flex-direction:column;gap:14px;">
                    <div><div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;"><span style="font-size:13px;color:var(--text-light);">Compartieron datos con Sophi</span><span style="font-family:var(--hyf-mono);font-size:13px;color:var(--text-light);">62</span></div><div style="height:6px;background:var(--bg-deep-3);border-radius:3px;overflow:hidden;"><div style="height:100%;width:100%;background:linear-gradient(90deg,var(--orange),var(--magenta));border-radius:3px;"></div></div></div>
                    <div><div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;"><span style="font-size:13px;color:var(--text-light);">Recibieron selección</span><span style="font-family:var(--hyf-mono);font-size:13px;color:var(--text-light);">54</span></div><div style="height:6px;background:var(--bg-deep-3);border-radius:3px;overflow:hidden;"><div style="height:100%;width:87%;background:linear-gradient(90deg,var(--orange),var(--magenta));border-radius:3px;"></div></div></div>
                    <div><div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;"><span style="font-size:13px;color:var(--text-light);">En conversación con agente</span><span style="font-family:var(--hyf-mono);font-size:13px;color:var(--text-light);">41</span></div><div style="height:6px;background:var(--bg-deep-3);border-radius:3px;overflow:hidden;"><div style="height:100%;width:66%;background:linear-gradient(90deg,var(--orange),var(--magenta));border-radius:3px;"></div></div></div>
                    <div><div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;"><span style="font-size:13px;color:#10B981;">Cerraron antes de viajar</span><span style="font-family:var(--hyf-mono);font-size:13px;color:#10B981;">38</span></div><div style="height:6px;background:var(--bg-deep-3);border-radius:3px;overflow:hidden;"><div style="height:100%;width:61%;background:#10B981;border-radius:3px;"></div></div></div>
                  </div>
                  <div style="margin-top:24px;padding:14px;background:var(--bg-deep-3);border:0.5px solid var(--border-dark-2);border-radius:10px;">
                    <div style="font-family:var(--hyf-mono);font-size:9px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:6px;">Resumen para tu reporte</div>
                    <div style="font-size:12px;color:var(--text-light-dim);line-height:1.55;"><span style="color:var(--text-light);">61% de la cohorte</span> ya aseguró alojamiento. Tiempo promedio al cierre: <span style="color:var(--text-light);">4,2 días</span>.</div>
                  </div>
                </div>
                <div class="dash-panel">
                  <div class="panel-head">
                    <div class="panel-title">Actividad reciente</div>
                    <span class="panel-actions">últimas 24h</span>
                  </div>
                  <div class="event-log">
                    <div class="event"><span class="event-time">09:12</span><span class="event-type ok">closed</span><span class="event-msg">M. Tanaka 🇯🇵 · cerró en <span class="hl">Madrid</span></span></div>
                    <div class="event"><span class="event-time">10:48</span><span class="event-type">selección</span><span class="event-msg">A. Okonkwo 🇳🇬 · 3 opciones enviadas</span></div>
                    <div class="event"><span class="event-time">11:30</span><span class="event-type ok">closed</span><span class="event-msg">L. Rossi 🇮🇹 · cerró en <span class="hl">Barcelona</span></span></div>
                    <div class="event"><span class="event-time">13:05</span><span class="event-type">paso</span><span class="event-msg">S. Petrov 🇧🇬 · agente asignado</span></div>
                    <div class="event"><span class="event-time">14:22</span><span class="event-type alert">attention</span><span class="event-msg">D. Kim 🇰🇷 · <span class="hl-m">sin respuesta 48h</span></span></div>
                    <div class="event"><span class="event-time">15:40</span><span class="event-type ok">closed</span><span class="event-msg">P. Andersson 🇸🇪 · cerró en <span class="hl">Santiago</span></span></div>
                  </div>
                  <div style="margin-top:24px;display:grid;grid-template-columns:1fr 1fr;gap:12px;">
                    <div style="padding:14px;background:var(--bg-deep-3);border:0.5px solid var(--border-dark-2);border-radius:10px;"><div style="font-family:var(--hyf-display);font-size:24px;color:var(--text-light);font-weight:500;letter-spacing:-0.03em;">94%</div><div style="font-size:10px;color:var(--text-light-faint);font-family:var(--hyf-mono);margin-top:2px;">satisfacción post-llegada</div></div>
                    <div style="padding:14px;background:var(--bg-deep-3);border:0.5px solid var(--border-dark-2);border-radius:10px;"><div style="font-family:var(--hyf-display);font-size:24px;font-weight:500;letter-spacing:-0.03em;background:linear-gradient(135deg,#FF8533,#D62E96);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;">0</div><div style="font-size:10px;color:var(--text-light-faint);font-family:var(--hyf-mono);margin-top:2px;">casos escalados a la U.</div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="section-divider"></div> -->

      <section class="section reveal">
        <!-- <span class="eyebrow"><span class="dim">/section_02</span> · qué resuelve para tu universidad</span> -->
        <h2>{{ $t('homeNuevo.universities_features.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.universities_features.title_emphasis') }}</span></h2>
        <div class="features-grid">
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.universities_features.1.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.universities_features.1.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.universities_features.1.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.universities_features.2.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.universities_features.2.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.universities_features.2.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.universities_features.3.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.universities_features.3.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.universities_features.3.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.universities_features.4.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.universities_features.4.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.universities_features.4.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.universities_features.5.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.universities_features.5.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.universities_features.5.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.universities_features.6.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.universities_features.6.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.universities_features.6.desc') }}</div>
          </div>
        </div>
      </section>

      <div class="section-divider"></div>

      <section class="section reveal" id="universities-how">
        <!-- <span class="eyebrow"><span class="dim">/section_01</span> · cómo funciona la alianza</span> -->
        <h2>{{ $t('homeNuevo.universities_how.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.universities_how.title_emphasis') }}</span></h2>
        <p class="subhead">{{ $t('homeNuevo.universities_how.subhead') }}</p>
        <div class="steps-grid">
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.universities_how.steps.1.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.universities_how.steps.1.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.universities_how.steps.1.body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.universities_how.steps.2.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.universities_how.steps.2.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.universities_how.steps.2.body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.universities_how.steps.3.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.universities_how.steps.3.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.universities_how.steps.3.body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.universities_how.steps.4.num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.universities_how.steps.4.title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.universities_how.steps.4.body') }}</div>
          </div>
        </div>
      </section>
<!-- 
      <div class="section-divider"></div> -->

      <section class="section-narrow reveal">
        <!-- <span class="eyebrow"><span class="dim">/section_03</span> · quiénes ya trabajan con nosotros</span> -->
        <h2>{{ $t('homeNuevo.universities_social.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.universities_social.title_emphasis') }}</span></h2>
        <div style="margin-top: 48px;">
          <div class="testimonial">
            <div class="testimonial-quote">"{{ $t('homeNuevo.universities_social.testimonial.quote') }}"</div>
            <div class="testimonial-meta"><strong>{{ $t('homeNuevo.universities_social.testimonial.meta_title') }}</strong> · {{ $t('homeNuevo.universities_social.testimonial.meta') }}</div>
          </div>
        </div>
      </section>

      <section class="section reveal">
        <div class="final-cta-block">
          <div class="h">{{ $t('homeNuevo.universities_final.title_main') }}<br/><em>{{ $t('homeNuevo.universities_final.title_emphasis') }}</em></div>
          <p class="sub">{{ $t('homeNuevo.universities_final.subhead') }}</p>
          <a :href="whatsappUrl" class="cta cta-primary" target="_blank" rel="noopener noreferrer">{{ $t('homeNuevo.universities_final.cta') }}</a>
          <div class="cta-meta">
            <span>{{ $t('homeNuevo.universities_final.email') }}</span><span> · </span><span>{{ $t('homeNuevo.universities_final.response_time') }}</span><span> · </span><span>{{ $t('homeNuevo.universities_final.note') }}</span>
          </div>
        </div>
      </section>

    </div><!-- END UNIVERSITIES VIEW -->

    <!-- ═══════════════════════════════════════════════════════ HOSTS VIEW -->
    <div v-show="currentView === 'hosts'" data-view="hosts">

      <section class="hero-section">
        <div class="hero-bg"></div>
        <div class="hero-grid"></div>
        <!-- <div class="eyebrow"><span class="dim">/ hosts /</span> property owners</div> -->
        <h1 class="reveal">{{ $t('homeNuevo.hosts.hero_title') }}<br/><span class="gradient-text">{{ $t('homeNuevo.hosts.hero_emphasis') }}</span></h1>
        <p class="subhead reveal reveal-d1">{{ $t('homeNuevo.hosts.hero_subhead') }}</p>
        <div class="cta-row reveal reveal-d2">
          <router-link v-if="registroSameHost" :to="{ name: 'registro-alojamiento' }" class="cta cta-gradient">{{ $t('homeNuevo.hosts.cta') }}</router-link>
          <a v-else :href="registroAlojamientoUrl" class="cta cta-gradient" target="_blank" rel="noopener noreferrer">{{ $t('homeNuevo.hosts.cta') }}</a>
        </div>
        <div class="stat-row reveal reveal-d3" style="margin-top: 56px;">
          <div class="stat"><div class="stat-val">0<span style="font-size:24px;color:var(--text-dim);">%</span></div><div class="stat-lbl">{{ $t('homeNuevo.hosts.stats.commission') }}</div></div>
          <div class="stat"><div class="stat-val">5,2<span style="font-size:24px;color:var(--text-dim);">m</span></div><div class="stat-lbl">{{ $t('homeNuevo.hosts.stats.avg_stay') }}</div></div>
          <div class="stat"><div class="stat-val"><span data-count="100">100</span><span style="font-size:24px;color:var(--text-dim);">%</span></div><div class="stat-lbl">{{ $t('homeNuevo.hosts.stats.verified_people') }}</div></div>
          <div class="stat"><div class="stat-val gradient">+<span data-count="85">85</span><span style="font-size:24px;">%</span></div><div class="stat-lbl">{{ $t('homeNuevo.hosts.stats.expected_occupancy') }}</div></div>
        </div>
      </section>

      <!-- <section class="section" style="padding-top: 56px;">
        <div class="system-meta">
          <span class="eyebrow magenta" style="margin-bottom: 0;">/system · incoming demand</span>
          <span class="pill magenta">PRE-QUALIFIED · LIVE</span>
        </div>
        <h2>Demanda que llega<br/><span class="serif" style="color:var(--text-dim);">ya filtrada.</span></h2>
        <p class="subhead">No te llegan 50 consultas para 5 reservas. Sophi califica antes de mostrarte nada. Esto es lo que entra a tu inbox: personas con presupuesto, fechas y documentación confirmados.</p>
        <div class="live-system">
          <div class="product-stage">
            <div class="app-frame">
              <div class="app-titlebar">
                <span class="dot r"></span><span class="dot y"></span><span class="dot g"></span>
                <span class="app-path"><span class="seg">host /</span> <span class="current">incoming_requests</span></span>
                <span class="app-status">LIVE · 2 nuevas</span>
              </div>
              <div class="dash-grid">
                <div class="dash-panel">
                  <div class="panel-head">
                    <div class="panel-title"><span style="width:8px;height:8px;border-radius:50%;background:var(--orange);display:inline-block;"></span> Solicitudes entrantes</div>
                    <span class="panel-title-meta">Estudio · Les Corts</span>
                  </div>
                  <div class="selección-card" style="grid-template-columns:48px 1fr auto;">
                    <div class="selección-thumb"></div>
                    <div class="selección-info"><div class="selección-title">Camila R. · 🇨🇱 Chile</div><div class="selección-meta">MBA IESE · 11 meses · €1.100/mes ✓</div></div>
                    <div style="font-family:var(--hyf-mono);font-size:10px;color:#10B981;border:0.5px solid rgba(16,185,129,0.3);background:rgba(16,185,129,0.1);padding:3px 8px;border-radius:4px;">match 98%</div>
                  </div>
                  <div class="selección-card" style="grid-template-columns:48px 1fr auto;">
                    <div class="selección-thumb t2"></div>
                    <div class="selección-info"><div class="selección-title">J. Müller · 🇩🇪 Alemania</div><div class="selección-meta">Relocación · 8 meses · €1.050/mes ✓</div></div>
                    <div style="font-family:var(--hyf-mono);font-size:10px;color:#10B981;border:0.5px solid rgba(16,185,129,0.3);background:rgba(16,185,129,0.1);padding:3px 8px;border-radius:4px;">match 91%</div>
                  </div>
                  <div class="selección-card" style="grid-template-columns:48px 1fr auto;">
                    <div class="selección-thumb t3"></div>
                    <div class="selección-info"><div class="selección-title">A. Silva · 🇧🇷 Brasil</div><div class="selección-meta">Postgrado · 6 meses · €980/mes ✓</div></div>
                    <div style="font-family:var(--hyf-mono);font-size:10px;color:var(--orange-bright);border:0.5px solid rgba(252,112,16,0.3);background:rgba(252,112,16,0.1);padding:3px 8px;border-radius:4px;">match 84%</div>
                  </div>
                  <div style="margin-top:20px;padding:12px 14px;background:rgba(252,112,16,0.10);border:0.5px solid rgba(252,112,16,0.25);border-radius:10px;">
                    <div style="font-family:var(--hyf-mono);font-size:9px;color:var(--orange-bright);text-transform:uppercase;letter-spacing:0.06em;margin-bottom:4px;">Filtrado por Sophi</div>
                    <div style="font-size:12px;color:var(--text-light-dim);line-height:1.5;">17 consultas recibidas esta semana · <span style="color:var(--text-light);">3 pasaron el filtro</span> y llegaron a ti.</div>
                  </div>
                </div>
                <div class="dash-panel">
                  <div class="panel-head">
                    <div class="panel-title">Tu propiedad</div>
                    <span class="panel-actions">próximos 12m</span>
                  </div>
                  <div style="display:flex;align-items:baseline;gap:12px;margin-bottom:20px;">
                    <div style="font-family:var(--hyf-display);font-size:44px;font-weight:300;letter-spacing:-0.04em;background:linear-gradient(135deg,var(--orange-bright),var(--magenta-bright));-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;">89%</div>
                    <div>
                      <div style="font-family:var(--hyf-mono);font-size:10px;color:var(--text-light-faint);text-transform:uppercase;letter-spacing:0.04em;">ocupación proyectada</div>
                      <div style="font-size:12px;color:var(--text-light-dim);margin-top:2px;">vs 61% promedio short-term</div>
                    </div>
                  </div>
                  <div class="event-log">
                    <div class="event"><span class="event-time">lun</span><span class="event-type ok">booked</span><span class="event-msg">Camila R. · <span class="hl">11 meses</span> confirmado</span></div>
                    <div class="event"><span class="event-time">mar</span><span class="event-type">request</span><span class="event-msg">J. Müller · esperando tu respuesta</span></div>
                    <div class="event"><span class="event-time">mié</span><span class="event-type">request</span><span class="event-msg">A. Silva · esperando tu respuesta</span></div>
                    <div class="event"><span class="event-time">--</span><span class="event-type" style="color:var(--text-light-faint);">idle</span><span class="event-msg" style="color:var(--text-light-faint);">sin huecos de vacancia detectados</span></div>
                  </div>
                  <div style="margin-top:24px;display:grid;grid-template-columns:1fr 1fr;gap:12px;">
                    <div style="padding:14px;background:var(--bg-deep-3);border:0.5px solid var(--border-dark-2);border-radius:10px;"><div style="font-family:var(--hyf-display);font-size:22px;color:var(--text-light);font-weight:500;letter-spacing:-0.03em;">5,2 m</div><div style="font-size:10px;color:var(--text-light-faint);font-family:var(--hyf-mono);margin-top:2px;">estadía promedio</div></div>
                    <div style="padding:14px;background:var(--bg-deep-3);border:0.5px solid var(--border-dark-2);border-radius:10px;"><div style="font-family:var(--hyf-display);font-size:22px;color:#10B981;font-weight:500;letter-spacing:-0.03em;">0%</div><div style="font-size:10px;color:var(--text-light-faint);font-family:var(--hyf-mono);margin-top:2px;">comisión host</div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> -->

      <div class="section-divider"></div>

      <section class="section reveal" id="hosts-how">
        <!-- <span class="eyebrow"><span class="dim">/section_01</span> · cómo funciona</span> -->
        <h2>{{ $t('homeNuevo.hosts_how.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.hosts_how.title_emphasis') }}</span></h2>
        <p class="subhead">{{ $t('homeNuevo.hosts_how.subhead') }}</p>
        <div class="steps-grid">
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.hosts_how.steps.1_num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.hosts_how.steps.1_title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.hosts_how.steps.1_body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.hosts_how.steps.2_num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.hosts_how.steps.2_title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.hosts_how.steps.2_body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.hosts_how.steps.3_num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.hosts_how.steps.3_title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.hosts_how.steps.3_body') }}</div>
          </div>
          <div class="step-item">
            <div class="step-num">{{ $t('homeNuevo.hosts_how.steps.4_num') }}</div>
            <div><div class="step-title">{{ $t('homeNuevo.hosts_how.steps.4_title') }}</div></div>
            <div class="step-body">{{ $t('homeNuevo.hosts_how.steps.4_body') }}</div>
          </div>
        </div>
      </section>

      <div class="section-divider"></div>

      <section class="section-narrow reveal">
        <!-- <span class="eyebrow"><span class="dim">/section_03</span> · qué tipo de propiedades aceptamos</span> -->
        <h2>{{ $t('homeNuevo.hosts_features.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.hosts_features.title_emphasis') }}</span></h2>
        <div style="margin-top:48px;border-top:0.5px solid var(--border);">
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;border-bottom:0.5px solid var(--border);"><div class="eyebrow-light">{{ $t('homeNuevo.hosts_requirements.rows.1.label') }}</div><div class="body">{{ $t('homeNuevo.hosts_requirements.rows.1.body') }}</div></div>
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;border-bottom:0.5px solid var(--border);"><div class="eyebrow-light">{{ $t('homeNuevo.hosts_requirements.rows.2.label') }}</div><div class="body">{{ $t('homeNuevo.hosts_requirements.rows.2.body') }}</div></div>
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;border-bottom:0.5px solid var(--border);"><div class="eyebrow-light">{{ $t('homeNuevo.hosts_requirements.rows.3.label') }}</div><div class="body">{{ $t('homeNuevo.hosts_requirements.rows.3.body') }}</div></div>
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;border-bottom:0.5px solid var(--border);"><div class="eyebrow-light">{{ $t('homeNuevo.hosts_requirements.rows.4.label') }}</div><div class="body">{{ $t('homeNuevo.hosts_requirements.rows.4.body') }}</div></div>
          <div style="display:grid;grid-template-columns:200px 1fr;gap:24px;padding:20px 0;"><div class="eyebrow-light">{{ $t('homeNuevo.hosts_requirements.rows.5.label') }}</div><div class="body">{{ $t('homeNuevo.hosts_requirements.rows.5.body') }}</div></div>
        </div>
      </section>

      <div class="section-divider"></div>

      <section class="section reveal">
        <!-- <span class="eyebrow"><span class="dim">/section_02</span> · por qué hosts trabajan con nosotros</span> -->
        <h2>{{ $t('homeNuevo.hosts_channel.title_main') }} <span class="serif" style="color:var(--text-dim);">{{ $t('homeNuevo.hosts_channel.title_emphasis') }}</span></h2>
        <div class="features-grid">
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.hosts_features.1.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.hosts_features.1.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.hosts_features.1.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.hosts_features.2.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.hosts_features.2.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.hosts_features.2.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.hosts_features.3.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.hosts_features.3.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.hosts_features.3.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.hosts_features.4.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.hosts_features.4.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.hosts_features.4.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.hosts_features.5.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.hosts_features.5.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.hosts_features.5.desc') }}</div>
          </div>
          <div class="feature">
            <div class="tag">{{ $t('homeNuevo.hosts_features.6.tag') }}</div>
            <div class="name">{{ $t('homeNuevo.hosts_features.6.name') }}</div>
            <div class="desc">{{ $t('homeNuevo.hosts_features.6.desc') }}</div>
          </div>
        </div>
      </section>

      <section class="section reveal">
        <div class="final-cta-block">
          <div class="h">{{ $t('homeNuevo.hosts_final.title_main') }}<br/><em>{{ $t('homeNuevo.hosts_final.title_emphasis') }}</em></div>
          <p class="sub">{{ $t('homeNuevo.hosts_final.subhead') }}</p>
          <router-link v-if="registroSameHost" :to="{ name: 'registro-alojamiento' }" class="cta cta-primary">{{ $t('homeNuevo.hosts.cta') }}</router-link>
          <a v-else :href="registroAlojamientoUrl" class="cta cta-primary">{{ $t('homeNuevo.hosts.cta') }}</a>
          <div class="cta-meta">
            <span>{{ $t('homeNuevo.hosts_final.email') }}</span><span> · </span><span>{{ $t('homeNuevo.hosts_final.verification') }}</span><span> · </span><span>{{ $t('homeNuevo.hosts_final.note') }}</span>
          </div>
        </div>
      </section>

    </div><!-- END HOSTS VIEW -->

    <FooterNuevo />

  </div>
</template>

<script>
// Logo del menú en naranja de marca (#FC7010). El SVG no tiene margen
// alrededor, a diferencia del PNG negro: por eso el ancho es menor (ver CSS).
import logoHorizontal from '@/new-assets/logo-horizontal.svg'
import logoMark from '@/assets/hyf-logo-mark-orange.png'
import FooterNuevo from '@/components/Footer/FooterNuevo.vue'
import AppHeader from '@/components/Header/AppHeader.vue'

export default {
  name: 'HomeNuevo',
  components: {
    FooterNuevo,
    AppHeader
  },
  data () {
    return {
      logoHorizontal,
      logoMark,
      currentView: 'home',
      // "Ser partner" / "Agendar llamada": WhatsApp principal de House & Flats.
      whatsappUrl: 'https://wa.me/13055100028',
      stickyCtaVisible: false,
      langOpen: false,
      selectedLang: 'es',
      langs: [
        { code: 'es', text: 'ESP' },
        { code: 'en', text: 'ENG' },
        { code: 'fr', text: 'FRA' },
        { code: 'it', text: 'ITA' },
        { code: 'de', text: 'DEU' },
        { code: 'pt', text: 'POR' }
      ]
    }
  },
  computed: {
    currentLangText () {
      const lang = this.langs.find(l => l.code === this.selectedLang)
      return lang ? lang.text : 'ESP'
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    editarPerfilUrl () {
      const base = (process.env.VUE_APP_SITE_URL || window.location.origin).replace(/\/$/, '')
      return `${base}/editar-perfil`
    },
    registroAlojamientoUrl () {
      // Siempre el sitio en el que se está (local, staging o producción).
      const base = (process.env.VUE_APP_SITE_URL || window.location.origin).replace(/\/$/, '')
      return `${base}/registro-alojamiento`
    }
    ,
    registroSameHost () {
      if (typeof window === 'undefined') return true;
      try {
        const site = (process.env.VUE_APP_SITE_URL || window.location.origin).replace(/\/$/, '')
        const siteHost = new URL(site).host
        return window.location.host === siteHost
      } catch (e) {
        try {
          const target = new URL(this.registroAlojamientoUrl)
          return window.location.host === target.host
        } catch (e2) {
          return true
        }
      }
    }
  },
  watch: {
    currentView () {
      window.scrollTo({ top: 0, behavior: 'instant' })
    }
  },
  methods: {
    setView (view) {
      this.currentView = view
      this.$nextTick(() => {
        const container = this.$el.querySelector(`[data-view="${view}"]`)
        if (container && this._scrollObserver) {
          container.querySelectorAll('.reveal').forEach(el => {
            el.classList.remove('is-visible')
            this._scrollObserver.observe(el)
          })
        }
      })
    },
    goToSophi () {
      if (this.currentView !== 'home') {
        this.currentView = 'home'
        this.$nextTick(() => {
          const el = document.getElementById('sophi')
          if (el) el.scrollIntoView({ behavior: 'smooth' })
        })
      } else {
        const el = document.getElementById('sophi')
        if (el) el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    changeLang (langCode) {
      this.selectedLang = langCode
      this.$i18n.locale = langCode
      this.$store.state.iso639_1 = langCode
      localStorage.setItem('iso639_1', langCode)
      this.langOpen = false
      if (this.$store.getters.isLoggedIn) {
        this.$store.dispatch('changePreferLanguage', { language: langCode })
      }
    },
    closeLangOnOutside (e) {
      const sw = this.$el && this.$el.querySelector('.lang-switcher')
      if (sw && !sw.contains(e.target)) this.langOpen = false
    },
    _scrollToElement (id) {
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    _animateCount (el) {
      const target = parseInt(el.dataset.count, 10)
      const suffix = el.dataset.suffix || ''
      const duration = 2800
      const startTime = performance.now()
      el.textContent = '0' + suffix
      const tick = (now) => {
        const p = Math.min((now - startTime) / duration, 1)
        const eased = 1 - Math.pow(1 - p, 3)
        el.textContent = Math.round(eased * target) + suffix
        if (p < 1) requestAnimationFrame(tick)
      }
      requestAnimationFrame(tick)
    }
  },
  created () {
    const stored = localStorage.getItem('iso639_1')
    this.selectedLang = stored || this.$i18n.locale || 'es'

    // Detectar parámetro view en URL para navegar a secciones
    const viewParam = this.$route.query.view
    if (viewParam && ['partners', 'universities', 'hosts'].includes(viewParam)) {
      this.currentView = viewParam
      // Limpiar URL del parámetro
      this.$router.replace({ path: '/' })
    }

    // Detectar parámetro scroll para hacer scroll a elementos
    const scrollParam = this.$route.query.scroll
    if (scrollParam && ['sophi', 'how'].includes(scrollParam)) {
      this._scrollTarget = scrollParam
      // Limpiar URL del parámetro
      this.$router.replace({ path: '/' })
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeLangOnOutside)
    window.removeEventListener('scroll', this._stickyScrollHandler)
    window.removeEventListener('resize', this._stickyScrollHandler)
    // Limpiar listeners de footer links
    const footerLinks = this.$el.querySelectorAll('footer a[href*="view="]')
    footerLinks.forEach(link => {
      const clonedNode = link.cloneNode(true)
      link.parentNode.replaceChild(clonedNode, link)
    })
    // Limpiar listeners de scroll links
    const scrollLinks = this.$el.querySelectorAll('footer a[href*="scroll="]')
    scrollLinks.forEach(link => {
      const clonedNode = link.cloneNode(true)
      link.parentNode.replaceChild(clonedNode, link)
    })
  },
  mounted () {
    // Interceptar clics en links del footer para cambiar vista internamente
    const footerLinks = this.$el.querySelectorAll('footer a[href*="view="]')
    footerLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const urlParams = new URLSearchParams(new URL(link.href, window.location.origin).search)
        const view = urlParams.get('view')
        if (view && ['partners', 'universities', 'hosts'].includes(view)) {
          e.preventDefault()
          this.setView(view)
        }
      })
    })

    // Interceptar clics en links del footer para scroll internamente
    const scrollLinks = this.$el.querySelectorAll('footer a[href*="scroll="]')
    scrollLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const urlParams = new URLSearchParams(new URL(link.href, window.location.origin).search)
        const scroll = urlParams.get('scroll')
        if (scroll && ['sophi', 'how'].includes(scroll)) {
          e.preventDefault()
          this._scrollToElement(scroll)
        }
      })
    })

    // Si hay un target de scroll desde parámetro URL, hacer scroll después de un pequeño delay
    if (this._scrollTarget) {
      this.$nextTick(() => {
        setTimeout(() => this._scrollToElement(this._scrollTarget), 100)
      })
    }

    document.addEventListener('click', this.closeLangOnOutside)
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          entry.target.querySelectorAll('[data-count]').forEach(el => this._animateCount(el))
          observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' })
    this._scrollObserver = observer
    this.$el.querySelectorAll('.reveal').forEach(el => observer.observe(el))

    // Flow card: sequential step highlight animation
    const flowSteps = Array.from(this.$el.querySelectorAll('.hero-flow-card .flow-step'))
    const flowResult = this.$el.querySelector('.hero-flow-card .flow-result')
    const STEP_MS = 850
    const START_DELAY = 800 // wait for card reveal (0.24s delay + 0.7s transition)
    flowSteps.forEach((step, i) => {
      setTimeout(() => {
        if (i > 0) flowSteps[i - 1].classList.remove('step-active')
        step.classList.add('step-active')
        if (i === flowSteps.length - 1) {
          setTimeout(() => flowResult.classList.add('step-result-show'), 300)
        }
      }, START_DELAY + i * STEP_MS)
    })

    // Sticky CTA: aparece cuando el CTA principal deja de estar visible.
    this._stickyScrollHandler = () => {
      const heroCta = this.$el.querySelector('.hero-section .cta-row .cta-recibir')
      const nav = this.$el.querySelector('.nav')
      const navBottom = nav ? nav.getBoundingClientRect().bottom : 0
      this.stickyCtaVisible = heroCta
        ? heroCta.getBoundingClientRect().bottom <= navBottom
        : false
    }
    this._stickyScrollHandler()
    window.addEventListener('scroll', this._stickyScrollHandler, { passive: true })
    window.addEventListener('resize', this._stickyScrollHandler, { passive: true })
  }
}
</script>

<style>
/* ═══════════════════════════════════════════════════════════════════
   H&F WEB SYSTEM v2 — Tech proptech startup
   Calabaza + Violeta Rojizo · Ramp/Rippling/Mercury energy
   ═══════════════════════════════════════════════════════════════════ */

@import url('https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700;800;900&family=Geist+Mono:wght@400;500;600&family=Instrument+Serif:ital@0;1&display=swap');

.hyf-home {
  --orange: #FC7010;
  --orange-bright: #FF8533;
  --orange-soft: #FFF1E5;
  --orange-line: #FFD4AE;
  --orange-text: #B84800;

  --magenta: #B91E7C;
  --magenta-bright: #D62E96;
  --magenta-soft: #FCEAF4;
  --magenta-line: #F5BDD9;
  --magenta-text: #8C1660;

  --bg: #FFFFFF;
  --bg-subtle: #FAFAF9;
  --bg-muted: #F4F3F0;
  --bg-deep: #0A0A0B;
  --bg-deep-2: #131316;
  --bg-deep-3: #1C1C20;

  --border: #ECEAE4;
  --border-strong: #DBD9D2;
  --border-bright: #C7C4BC;
  --border-dark: rgba(255,255,255,0.08);
  --border-dark-2: rgba(255,255,255,0.14);

  --text: #0A0A0B;
  --text-mid: #383840;
  --text-dim: #6E6E76;
  --text-faint: #A0A0A8;
  --text-mute: #C7C7CD;

  --text-light: #F5F5F7;
  --text-light-dim: #A1A1A8;
  --text-light-faint: #6B6B73;

  --hyf-display: 'Geist', sans-serif;
  --hyf-body: 'Geist', sans-serif;
  --hyf-serif: 'Instrument Serif', serif;
  --hyf-mono: 'Geist Mono', 'JetBrains Mono', monospace;

  --max-w: 1240px;
  --max-w-narrow: 920px;

  font-family: var(--hyf-body);
  color: var(--text);
  background: var(--bg);
  font-weight: 400;
  font-size: 16px;
  line-height: 1.55;
  letter-spacing: -0.01em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* La ruta oculta el header del layout (meta.hideHeader), pero DefaultLayout
     igual deja 60 px de padding-top: sin esto el header quedaba despegado. */
  margin-top: -60px;
}

.hyf-home *, .hyf-home *::before, .hyf-home *::after {
  box-sizing: border-box;
}

/* NAV: la portada usa el header del sitio (AppHeader). Acá solo los enlaces
   y el botón que van en su centro. */
.hyf-home .home-header .nav-links { display: flex; align-items: center; gap: 28px; }
.hyf-home .home-header .nav-links a { font-family: 'DM Sans', system-ui, sans-serif; font-size: 16px; font-weight: 600; letter-spacing: normal; }
.hyf-home .home-header .nav-cta { font-family: 'DM Sans', system-ui, sans-serif; font-size: 14px; font-weight: 700; letter-spacing: normal; padding: 10px 16px; white-space: nowrap; }
/* Donde no entran junto a moneda / idioma / cuenta, se ocultan (también están en el footer). */
@media (max-width: 1100px) {
  .hyf-home .home-header .nav-links { display: none; }
}
@media (max-width: 760px) {
  .hyf-home .home-header .nav-cta { display: none; }
}
.hyf-home .nav {
  position: sticky; top: 0; z-index: 50;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 0.5px solid rgba(10, 10, 11, 0.08);
}
.hyf-home .nav-inner { width: 100%; padding: 16px 32px; display: flex; justify-content: flex-start; align-items: center; gap: 48px; }
.hyf-home .brand { display: flex; align-items: center; gap: 0; font-family: var(--hyf-display); font-size: 14px; font-weight: 600; letter-spacing: -0.01em; color: var(--text); text-decoration: none; }
.hyf-home .brand-logo { display: block; width: 210px; height: auto; }
/* El SVG naranja no trae margen: 178 px equivale a las letras del PNG de 210 */
.hyf-home .nav .brand-logo-desktop { width: 178px; }
.hyf-home .brand-logo-mobile { display: none; }
.hyf-home .footer .brand-logo { width: 168px; }
.hyf-home .nav-links { display: flex; align-items: center; gap: 32px; flex: 1;  justify-content: center; }
.hyf-home .nav-links a { font-size: 20px; color: rgba(10, 10, 11, 0.58); text-decoration: none; font-weight: 500; transition: color 0.15s; }
.hyf-home .nav-links a:hover { color: var(--text); }
.hyf-home .nav-cta { background: #0A0A0B; color: #FFFFFF !important; padding: 9px 15px; border-radius: 999px; font-size: 13px; font-weight: 500; text-decoration: none; letter-spacing: -0.01em; }
.hyf-home .nav-right { display: flex; align-items: center; gap: 10px; margin-left: auto; flex-shrink: 0; }
.hyf-home .lang-switcher { position: relative; }
.hyf-home .lang-btn { display: flex; align-items: center; gap: 6px; background: transparent; border: 0.5px solid var(--border-strong); border-radius: 999px; padding: 10px 16px; font-family: var(--hyf-mono); font-size: 13px; font-weight: 500; color: var(--text-dim); cursor: pointer; transition: all 0.15s; letter-spacing: 0.04em; }
.hyf-home .lang-btn:hover { border-color: var(--text); color: var(--text); }
.hyf-home .lang-code { font-family: var(--hyf-mono); font-size: 11px; letter-spacing: 0.04em; }
.hyf-home .lang-chevron { font-size: 10px; line-height: 1; transition: transform 0.15s; display: inline-block; }
.hyf-home .lang-chevron.is-open { transform: rotate(180deg); }
.hyf-home .lang-dropdown { position: absolute; top: calc(100% + 6px); right: 0; background: #fff; border: 0.5px solid var(--border-strong); border-radius: 12px; padding: 4px; box-shadow: 0 8px 24px rgba(0,0,0,0.08); z-index: 200; min-width: 80px; }
.hyf-home .lang-option { display: block; width: 100%; background: transparent; border: none; padding: 7px 12px; font-family: var(--hyf-mono); font-size: 11px; font-weight: 500; color: var(--text-dim); cursor: pointer; border-radius: 8px; text-align: left; letter-spacing: 0.04em; transition: all 0.1s; }
.hyf-home .lang-option:hover { background: var(--bg-subtle); color: var(--text); }
.hyf-home .lang-option.active { color: var(--orange); font-weight: 600; }
.lang-fade-enter-active, .lang-fade-leave-active { transition: opacity 0.12s, transform 0.12s; }
.lang-fade-enter, .lang-fade-leave-to { opacity: 0; transform: translateY(-4px); }
.hyf-home .btn-login { display: inline-flex; align-items: center; background: var(--bg-subtle); border: 0.5px solid var(--border-strong); border-radius: 999px; padding: 7px 14px; font-size: 13px; font-weight: 500; color: var(--text); text-decoration: none; transition: all 0.15s; letter-spacing: -0.01em; white-space: nowrap; }
.hyf-home .btn-login:hover { background: var(--text); color: #fff; border-color: var(--text); }
.hyf-home .btn-profile { display: inline-flex; align-items: center; justify-content: center; width: 42px; height: 42px; background: var(--bg-subtle); border: 0.5px solid var(--border-strong); border-radius: 999px; color: var(--text); text-decoration: none; transition: all 0.15s; flex-shrink: 0; }
.hyf-home .btn-profile:hover { background: var(--text); color: #fff; border-color: var(--text); }

/* STICKY CTA BAR */
.hyf-home .sticky-cta-bar {
  position: fixed;
  top: 88px;
  left: 0;
  right: 0;
  z-index: 49;
  display: flex;
  justify-content: center;
  padding: 10px 16px;
  pointer-events: none;
}
.hyf-home .sticky-cta-bar .cta {
  pointer-events: auto;
}
.sticky-fade-enter-active, .sticky-fade-leave-active { transition: opacity 0.2s, transform 0.2s; }
.sticky-fade-enter, .sticky-fade-leave-to { opacity: 0; transform: translateY(-8px); }

/* SECTIONS */
.hyf-home .section { max-width: var(--max-w); margin: 0 auto; padding: 112px 32px; position: relative; }
.hyf-home .section-narrow { max-width: var(--max-w-narrow); margin: 0 auto; padding: 112px 32px; }

/* CTA: reducir espacio vertical entre la sección anterior y la CTA final */
.hyf-home #cta { padding-top: 24px; padding-bottom: 24px; }

/* HERO */
.hyf-home .hero-section { position: relative; overflow: hidden; padding: 112px 32px 112px; max-width: var(--max-w); margin: 0 auto; }
.hyf-home .hero-bg { position: absolute; inset: 0; pointer-events: none; z-index: 0;
  background:
    radial-gradient(ellipse 70% 62% at 15% -8%, rgba(252,112,16,0.13) 0%, transparent 58%),
    radial-gradient(ellipse 56% 48% at 86% 4%, rgba(185,30,124,0.12) 0%, transparent 58%),
    radial-gradient(ellipse 60% 50% at 100% 90%, rgba(252,112,16,0.06) 0%, transparent 55%);
}
.hyf-home .hero-grid { position: absolute; inset: 0; pointer-events: none; z-index: 0; background-image: linear-gradient(rgba(0,0,0,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.025) 1px, transparent 1px); background-size: 48px 48px; mask-image: radial-gradient(ellipse 70% 60% at 50% 30%, black 0%, transparent 80%); -webkit-mask-image: radial-gradient(ellipse 70% 60% at 50% 30%, black 0%, transparent 80%); }
.hyf-home .hero-section > * { position: relative; z-index: 1; }

.hyf-home .hero-shell {
  position: relative; z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.72fr);
  gap: clamp(40px, 6vw, 86px);
  align-items: center;
}
.hyf-home .hero-copy { min-width: 0; }

.hyf-home .hero-metrics {
  position: relative; z-index: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  overflow: hidden;
  margin-top: 44px;
  border: 0.5px solid rgba(10, 10, 11, 0.08);
  border-radius: 24px;
  background: rgba(10, 10, 11, 0.08);
  box-shadow: 0 20px 60px rgba(10, 10, 11, 0.06);
}
.hyf-home .hero-metrics div { min-height: 132px; padding: 22px; background: rgba(255, 255, 255, 0.82); }
.hyf-home .hero-metrics strong { display: block; margin-bottom: 26px; font-size: clamp(34px, 4vw, 54px); line-height: 1; letter-spacing: -0.05em; }
.hyf-home .hero-metrics span { display: block; max-width: 210px; color: rgba(10, 10, 11, 0.56); font-family: var(--hyf-mono); font-size: 11px; line-height: 1.45; text-transform: uppercase; letter-spacing: 0.04em; }

/* TYPOGRAPHY */
.hyf-home .eyebrow { font-family: var(--hyf-mono); font-size: 12px; font-weight: 500; letter-spacing: 0.04em; text-transform: uppercase; color: var(--orange-text); margin-bottom: 24px; display: inline-flex; align-items: center; gap: 8px; }
.hyf-home .eyebrow::before { content: ''; width: 6px; height: 6px; background: var(--orange); border-radius: 50%; box-shadow: 0 0 8px rgba(252,112,16,0.6); }
.hyf-home .eyebrow.magenta { color: var(--magenta-text); }
.hyf-home .eyebrow.magenta::before { background: var(--magenta); box-shadow: 0 0 8px rgba(185,30,124,0.6); }
.hyf-home .eyebrow .dim { color: var(--text-faint); }

.hyf-home h1, .hyf-home .h1 { font-family: var(--hyf-display); font-size: clamp(52px, 7vw, 100px); font-weight: 560; line-height: 0.94; letter-spacing: -0.058em; color: var(--text); max-width: 980px; }
.hyf-home h2, .hyf-home .h2 { font-family: var(--hyf-display); font-size: clamp(34px, 4.5vw, 60px); font-weight: 560; line-height: 1.02; letter-spacing: -0.045em; color: var(--text); }
.hyf-home h3, .hyf-home .h3 { font-family: var(--hyf-display); font-size: 24px; font-weight: 500; line-height: 1.18; letter-spacing: -0.028em; }
.hyf-home h4, .hyf-home .h4 { font-family: var(--hyf-display); font-size: 15px; font-weight: 500; letter-spacing: -0.01em; }

.hyf-home .serif { font-family: var(--hyf-serif); font-style: italic; font-weight: 400; letter-spacing: -0.01em; }
.hyf-home .subhead { font-size: 20px; line-height: 1.5; color: rgba(10, 10, 11, 0.64); font-weight: 400; letter-spacing: -0.014em; max-width: 700px; margin-top: 28px; }
.hyf-home .body { font-size: 15px; line-height: 1.6; color: var(--text-mid); }
.hyf-home .muted { color: var(--text-dim); }
.hyf-home strong { font-weight: 600; color: var(--text); }

.hyf-home .gradient-text { background: linear-gradient(135deg, var(--orange) 0%, var(--magenta) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }

/* PILLS */
.hyf-home .pill { display: inline-flex; align-items: center; gap: 6px; padding: 4px 10px; border-radius: 99px; font-family: var(--hyf-mono); font-size: 11px; font-weight: 500; border: 0.5px solid var(--orange-line); background: var(--orange-soft); color: var(--orange-text); }
.hyf-home .pill::before { content: ''; width: 5px; height: 5px; background: var(--orange); border-radius: 50%; }
.hyf-home .pill.magenta { background: var(--magenta-soft); border-color: var(--magenta-line); color: var(--magenta-text); }
.hyf-home .pill.magenta::before { background: var(--magenta); }
.hyf-home .pill.live::before { background: #10B981; box-shadow: 0 0 6px #10B981; animation: hyf-pulse 2s infinite; }
.hyf-home .pill.neutral { background: var(--bg-subtle); border-color: var(--border-strong); color: var(--text-dim); }
.hyf-home .pill.neutral::before { background: var(--text-faint); }

@keyframes hyf-pulse { 0%,100% { opacity:1; } 50% { opacity:0.55; } }

/* CTAs */
.hyf-home .cta { display: inline-flex; align-items: center; gap: 10px; padding: 14px 22px; border-radius: 999px; font-family: var(--hyf-display); font-size: 15px; font-weight: 500; text-decoration: none; letter-spacing: -0.01em; transition: all 0.18s ease; cursor: pointer; border: none; }
.hyf-home .cta.cta-recibir { padding: 18px 28px; font-size: 17px; font-weight: 600; }
.hyf-home .cta-primary { background: var(--text); color: var(--bg); }
.hyf-home .cta-primary:hover { transform: translateY(-1px); box-shadow: 0 12px 32px rgba(252, 112, 16, 0.28); }
.hyf-home .cta-secondary { background: transparent; color: var(--text-mid); padding: 14px 8px; }
.hyf-home .cta-secondary:hover { color: var(--text); }
.hyf-home .cta-gradient { background: linear-gradient(135deg, #FC7010 0%, #B91E7C 100%); color: white; box-shadow: 0 4px 16px rgba(185, 30, 124, 0.20); }
.hyf-home .cta-gradient:hover { transform: translateY(-1px); box-shadow: 0 12px 32px rgba(185, 30, 124, 0.32); }
.hyf-home .cta-gradient::after { content: '→'; font-family: var(--hyf-mono); transition: transform 0.2s; }
.hyf-home .cta-gradient:hover::after { transform: translateX(3px); }
.hyf-home .cta-row { display: flex; gap: 12px; margin-top: 36px; align-items: center; flex-wrap: wrap; }
.hyf-home .cta-meta { font-family: var(--hyf-mono); font-size: 12px; color: var(--text-faint); margin-top: 24px; display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }

/* INTAKE NOTE */
.hyf-home .intake-note { max-width: 620px; margin-top: 28px; padding: 18px 20px; border: 0.5px solid rgba(10, 10, 11, 0.08); border-radius: 20px; background: rgba(255, 255, 255, 0.72); box-shadow: 0 16px 42px rgba(10, 10, 11, 0.06); }
.hyf-home .intake-note span { display: block; margin-bottom: 12px; color: var(--orange-text); font-family: var(--hyf-mono); font-size: 10px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; }
.hyf-home .intake-note strong { display: block; margin-bottom: 6px; font-size: 17px; line-height: 1.2; }
.hyf-home .intake-note p { color: rgba(10, 10, 11, 0.58); font-size: 14px; line-height: 1.48; }

/* FLOW CARD */
.hyf-home .hero-flow-card {
  position: relative; overflow: hidden; padding: 18px;
  border: 1px solid rgba(10, 10, 11, 0.08); border-radius: 28px;
  background:
    radial-gradient(ellipse 70% 55% at 100% 0%, rgba(185, 30, 124, 0.13), transparent 58%),
    radial-gradient(ellipse 72% 52% at 0% 100%, rgba(252, 112, 16, 0.12), transparent 60%),
    rgba(255, 255, 255, 0.82);
  box-shadow: 0 30px 80px rgba(10, 10, 11, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.72);
}
.hyf-home .hero-flow-card::before { content: ""; position: absolute; inset: 0; background-image: linear-gradient(rgba(10, 10, 11, 0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(10, 10, 11, 0.035) 1px, transparent 1px); background-size: 34px 34px; mask-image: radial-gradient(ellipse 80% 70% at 55% 42%, black, transparent 84%); pointer-events: none; }
.hyf-home .flow-card-top, .hyf-home .flow-result, .hyf-home .flow-track { position: relative; z-index: 1; }
.hyf-home .flow-card-top { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding-bottom: 16px; margin-bottom: 4px; border-bottom: 0.5px solid rgba(10, 10, 11, 0.08); font-family: var(--hyf-mono); font-size: 11px; color: rgba(10, 10, 11, 0.58); text-transform: uppercase; letter-spacing: 0.05em; }
.hyf-home .flow-live { display: inline-flex; align-items: center; gap: 6px; color: #0E9F6E; }
.hyf-home .flow-live::before { content: ""; width: 6px; height: 6px; border-radius: 99px; background: #10B981; box-shadow: 0 0 10px rgba(16, 185, 129, 0.72); }
.hyf-home .flow-track { padding: 18px 0 12px; position: relative; }
.hyf-home .flow-line { position: absolute; left: 20px; top: 38px; bottom: 34px; width: 1px; background: linear-gradient(180deg, var(--orange), var(--magenta), rgba(10, 10, 11, 0.1)); }
.hyf-home .flow-step { position: relative; display: grid; grid-template-columns: 42px 1fr; gap: 14px; padding: 14px 0; transition: transform 0.18s ease; }
.hyf-home .flow-step:hover { transform: translateX(4px); }
.hyf-home .flow-index { position: relative; z-index: 1; width: 40px; height: 40px; display: grid; place-items: center; border: 1px solid rgba(10, 10, 11, 0.1); border-radius: 14px; background: rgba(255, 255, 255, 0.88); color: var(--magenta); font-family: var(--hyf-mono); font-size: 11px; font-weight: 600; transition: background 0.4s ease, box-shadow 0.4s ease, transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), color 0.4s ease, border-color 0.4s ease; }
.hyf-home .flow-step.active .flow-index { color: white; border-color: rgba(252, 112, 16, 0.5); background: linear-gradient(135deg, var(--orange), var(--magenta)); box-shadow: 0 10px 28px rgba(185, 30, 124, 0.22); }
.hyf-home .flow-step.step-active .flow-index { color: white; border-color: rgba(252, 112, 16, 0.5); background: linear-gradient(135deg, var(--orange), var(--magenta)); box-shadow: 0 10px 28px rgba(185, 30, 124, 0.22); transform: scale(1.18); }
.hyf-home .flow-step.step-active strong { font-size: 16.5px; }
.hyf-home .flow-step strong { display: block; color: var(--text); font-size: 15px; letter-spacing: -0.02em; transition: font-size 0.35s ease; }
.hyf-home .flow-step p { margin-top: 3px; color: rgba(10, 10, 11, 0.58); font-size: 13px; line-height: 1.42; }
.hyf-home .flow-result { margin-top: 8px; padding: 16px; border: none; border-radius: 18px; background: linear-gradient(135deg, #FC7010 0%, #B91E7C 100%); color: white; box-shadow: 0 8px 24px rgba(185, 30, 124, 0.20); opacity: 0; transform: translateY(10px); transition: opacity 0.55s ease, transform 0.55s ease; }
.hyf-home .flow-result.step-result-show { opacity: 1; transform: translateY(0); }
.hyf-home .flow-result span { display: block; margin-bottom: 8px; color: var(--text); font-family: var(--hyf-mono); font-size: 10px; letter-spacing: 0.06em; text-transform: uppercase; font-weight: 700; }
.hyf-home .flow-result strong { color: white; font-size: 18px; line-height: 1.18; }

/* PRODUCT STAGE — Sophi dashboard */
.hyf-home .product-stage { background: #09090B; border-radius: 30px; padding: 24px; position: relative; overflow: hidden; box-shadow: 0 34px 90px rgba(10, 10, 11, 0.22), 0 8px 30px rgba(185, 30, 124, 0.12); border: 1px solid var(--border-dark); }
.hyf-home .product-stage::before { content: ''; position: absolute; inset: 0; pointer-events: none; background: radial-gradient(ellipse 60% 40% at 0% 0%, rgba(252, 112, 16, 0.12) 0%, transparent 50%), radial-gradient(ellipse 40% 50% at 100% 100%, rgba(185, 30, 124, 0.10) 0%, transparent 50%); }
.hyf-home .product-stage::after { content: ''; position: absolute; inset: 0; pointer-events: none; background-image: linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px); background-size: 32px 32px; mask-image: radial-gradient(ellipse 90% 80% at 50% 50%, black 0%, transparent 90%); -webkit-mask-image: radial-gradient(ellipse 90% 80% at 50% 50%, black 0%, transparent 90%); }
.hyf-home .product-stage > * { position: relative; z-index: 1; }

.hyf-home .app-frame { background: var(--bg-deep-2); border-radius: 18px; border: 0.5px solid var(--border-dark-2); overflow: hidden; }
.hyf-home .app-titlebar { display: flex; align-items: center; gap: 8px; padding: 12px 16px; background: var(--bg-deep-3); border-bottom: 0.5px solid var(--border-dark); }
.hyf-home .dot { width: 12px; height: 12px; border-radius: 50%; }
.hyf-home .dot.r { background: #FF5F57; }
.hyf-home .dot.y { background: #FEBC2E; }
.hyf-home .dot.g { background: #28C840; }
.hyf-home .app-path { font-family: var(--hyf-mono); font-size: 11px; color: var(--text-light-faint); margin-left: 16px; }
.hyf-home .app-path .current { color: var(--text-light); }
.hyf-home .app-status { margin-left: auto; font-family: var(--hyf-mono); font-size: 10px; color: #10B981; display: flex; align-items: center; gap: 6px; }
.hyf-home .app-status::before { content: ''; width: 6px; height: 6px; background: #10B981; border-radius: 50%; box-shadow: 0 0 6px #10B981; animation: hyf-pulse 2s infinite; }

.hyf-home .dash-grid { display: grid; grid-template-columns: 1.1fr 1fr; gap: 1px; background: var(--border-dark); }
.hyf-home .dash-panel { background: var(--bg-deep-2); padding: 24px; min-height: 400px; }
.hyf-home .panel-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; padding-bottom: 14px; border-bottom: 0.5px solid var(--border-dark); }
.hyf-home .panel-title { font-family: var(--hyf-display); font-size: 13px; font-weight: 500; color: var(--text-light); display: flex; align-items: center; gap: 8px; }
.hyf-home .panel-title-meta { font-family: var(--hyf-mono); font-size: 10px; color: var(--text-light-faint); background: var(--bg-deep-3); padding: 3px 8px; border-radius: 4px; border: 0.5px solid var(--border-dark-2); }
.hyf-home .panel-actions { font-family: var(--hyf-mono); font-size: 10px; color: var(--text-light-faint); }

.hyf-home .msg { display: flex; flex-direction: column; margin-bottom: 14px; max-width: 86%; }
.hyf-home .msg-from { font-family: var(--hyf-mono); font-size: 9px; color: var(--text-light-faint); letter-spacing: 0.05em; text-transform: uppercase; margin-bottom: 4px; }
.hyf-home .msg-bubble { font-size: 13px; line-height: 1.45; padding: 10px 14px; border-radius: 12px; color: var(--text-light); }
.hyf-home .msg.sophi .msg-bubble { background: linear-gradient(135deg, rgba(252, 112, 16, 0.15) 0%, rgba(252, 112, 16, 0.05) 100%); border: 0.5px solid rgba(252, 112, 16, 0.25); border-bottom-left-radius: 4px; }
.hyf-home .msg.user { align-self: flex-end; align-items: flex-end; }
.hyf-home .msg.user .msg-bubble { background: var(--bg-deep-3); border: 0.5px solid var(--border-dark-2); border-bottom-right-radius: 4px; }
.hyf-home .msg-time { font-family: var(--hyf-mono); font-size: 9px; color: var(--text-light-faint); margin-top: 4px; }
.hyf-home .typing { display: inline-flex; align-items: center; gap: 4px; padding: 10px 14px; background: rgba(252, 112, 16, 0.08); border-radius: 12px; border-bottom-left-radius: 4px; border: 0.5px solid rgba(252, 112, 16, 0.2); }
.hyf-home .typing-dot { width: 6px; height: 6px; background: var(--orange); border-radius: 50%; animation: hyf-bounce 1.4s infinite ease-in-out; }
.hyf-home .typing-dot:nth-child(2) { animation-delay: 0.2s; }
.hyf-home .typing-dot:nth-child(3) { animation-delay: 0.4s; }
@keyframes hyf-bounce { 0%,60%,100% { transform: translateY(0); opacity: 0.4; } 30% { transform: translateY(-4px); opacity: 1; } }

.hyf-home .shortlist-card { background: var(--bg-deep-3); border: 0.5px solid var(--border-dark-2); border-radius: 10px; padding: 14px; margin-bottom: 10px; display: grid; grid-template-columns: 56px 1fr auto; gap: 14px; align-items: center; }
.hyf-home .shortlist-thumb { width: 56px; height: 56px; border-radius: 8px; background: linear-gradient(135deg, var(--orange) 0%, var(--magenta) 100%); }
.hyf-home .shortlist-thumb.t2 { background: linear-gradient(135deg, #0F561B 0%, #287C2C 100%); }
.hyf-home .shortlist-thumb.t3 { background: linear-gradient(135deg, #5F0A2B 0%, var(--magenta) 100%); }
.hyf-home .shortlist-title { font-family: var(--hyf-display); font-size: 13px; font-weight: 500; color: var(--text-light); margin-bottom: 3px; }
.hyf-home .shortlist-meta { font-size: 11px; color: var(--text-light-faint); }
.hyf-home .shortlist-price { font-family: var(--hyf-display); font-size: 14px; font-weight: 500; color: var(--text-light); white-space: nowrap; }
.hyf-home .shortlist-price small { font-size: 10px; color: var(--text-light-faint); display: block; font-weight: 400; }

.hyf-home .event-log { font-family: var(--hyf-mono); font-size: 11px; line-height: 1.7; }
.hyf-home .event { display: grid; grid-template-columns: 60px 100px 1fr; gap: 12px; padding: 6px 0; border-bottom: 0.5px solid var(--border-dark); color: var(--text-light-faint); }
.hyf-home .event:last-child { border-bottom: none; }
.hyf-home .event-time { color: var(--text-light-faint); }
.hyf-home .event-type { color: var(--text-light); }
.hyf-home .event-type.ok { color: #10B981; }
.hyf-home .event-type.warn { color: var(--orange-bright); }
.hyf-home .event-type.alert { color: var(--magenta-bright); }
.hyf-home .event-msg { color: var(--text-light-dim); }
.hyf-home .event-msg .hl { color: var(--orange-bright); }
.hyf-home .event-msg .hl-m { color: var(--magenta-bright); }

/* STEPS */
.hyf-home .steps-grid { display: grid; grid-template-columns: 1fr; margin-top: 64px; border-top: 0.5px solid var(--border); }
.hyf-home .step-item { display: grid; grid-template-columns: 100px 1fr 1.2fr; gap: 32px; padding: 36px 0; border-bottom: 0.5px solid var(--border); align-items: start; transition: background 0.2s; }
.hyf-home .step-num {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    color: var(--orange-text);
    font-weight: 700;
    letter-spacing: 0.5px;
}
.hyf-home .step-title { font-family: var(--hyf-display); font-size: 26px; font-weight: 500; letter-spacing: -0.028em; color: var(--text); line-height: 1.15; }
.hyf-home .step-body { font-size: 15px; color: var(--text-mid); line-height: 1.6; }

/* PV GRID */
.hyf-home .pv-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 34px; }
.hyf-home .pv-card { padding: 20px; border: 0.5px solid var(--border); border-radius: 20px; background: var(--bg-subtle); }
.hyf-home .pv-card span { display: block; margin-bottom: 34px; color: var(--magenta); font-family: var(--hyf-mono); font-size: 10px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; }
.hyf-home .pv-card strong { display: block; margin-bottom: 8px; font-size: 18px; line-height: 1.18; }
.hyf-home .pv-card p { color: rgba(10, 10, 11, 0.58); font-size: 13px; line-height: 1.5; }

/* PROBLEM CARDS */
.hyf-home .problem-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px; margin-top: 56px; }
.hyf-home .problem-card { background: var(--bg-subtle); border: 0.5px solid var(--border); border-radius: 18px; padding: 24px; position: relative; transition: all 0.2s; }
.hyf-home .problem-card:hover { border-color: var(--magenta-line); background: var(--bg); transform: translateY(-2px); box-shadow: 0 12px 32px rgba(185, 30, 124, 0.06); }
.hyf-home .problem-card .num { font-family: var(--hyf-mono); font-size: 12px; color: var(--magenta); margin-bottom: 14px; font-weight: 500; }
.hyf-home .problem-card .title { font-family: var(--hyf-display); font-size: 19px; font-weight: 500; letter-spacing: -0.022em; margin-bottom: 8px; color: var(--text); line-height: 1.25; }
.hyf-home .problem-card .body { font-size: 13px; color: var(--text-dim); line-height: 1.55; }

/* TESTIMONIALS */
.hyf-home .testimonial-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px; margin-top: 56px; }
.hyf-home .testimonial { background: var(--bg); border: 0.5px solid var(--border); border-radius: 18px; padding: 32px; display: flex; flex-direction: column; transition: all 0.2s; }
.hyf-home .testimonial:hover { border-color: var(--orange-line); box-shadow: 0 8px 24px rgba(252, 112, 16, 0.06); }
.hyf-home .testimonial-quote { font-family: var(--hyf-serif); font-style: italic; font-size: 20px; line-height: 1.4; color: var(--text); margin-bottom: 28px; flex: 1; }
.hyf-home .testimonial-meta { font-size: 12px; color: var(--text-dim); line-height: 1.5; }
.hyf-home .testimonial-meta strong { display: block; color: var(--text); font-weight: 500; font-size: 13px; margin-bottom: 2px; }

/* STATS */
.hyf-home .stat-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 40px; margin-top: 64px; padding: 48px 0; border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); }
.hyf-home .stat { display: flex; flex-direction: column; gap: 8px; align-items: flex-start; }
.hyf-home .stat-val { font-family: var(--hyf-display); font-size: 44px; font-weight: 600; line-height: 1; letter-spacing: -0.038em; color: var(--text); }
.hyf-home .stat-val.accent { color: var(--orange); }
.hyf-home .stat-val.magenta { color: var(--magenta); }
.hyf-home .stat-val.gradient { background: linear-gradient(135deg, var(--orange) 0%, var(--magenta) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
.hyf-home .stat-lbl { font-family: var(--hyf-mono); font-size: 11px; font-weight: 700; color: var(--text-dim); letter-spacing: 0.04em; text-transform: uppercase; line-height: 1.4; }
.hyf-home .stat-detail { font-family: var(--hyf-mono); font-size: 10px; color: var(--text-dim); letter-spacing: 0.02em; line-height: 1.6; margin-top: 6px; }
.hyf-home .stat-markets-list { display: none; font-family: var(--hyf-mono); font-size: 10px; color: var(--text-dim); letter-spacing: 0.02em; line-height: 1.6; margin-top: 8px; }
.hyf-home .stat-markets-hover:hover .stat-markets-list { display: block; animation: fadeIn 0.3s ease; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* OPERATING LOOP */
.hyf-home .ops-loop-section { padding-top: 104px; }
.hyf-home .ops-loop-head { max-width: 920px; }
.hyf-home .ops-loop-grid { display: grid; grid-template-columns: 0.95fr 1.05fr; gap: 18px; align-items: start; margin-top: 56px; }

.hyf-home .ops-console { position: sticky; top: 92px; overflow: hidden; border: 0.5px solid var(--border); border-radius: 26px; background: #fffaf6; box-shadow: 0 22px 70px rgba(10, 10, 11, 0.08); }
.hyf-home .console-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; padding: 20px; border-bottom: 0.5px solid var(--border); }
.hyf-home .console-top strong { display: block; font-size: 26px; line-height: 1; }
.hyf-home .console-top span:not(.console-count) { display: block; margin-top: 4px; color: var(--text-dim); font-size: 13px; }
.hyf-home .console-count { display: inline-flex; min-width: 34px; justify-content: center; padding: 4px 8px; border-radius: 999px; background: var(--orange); color: white; font-family: var(--hyf-mono); font-size: 11px; }
.hyf-home .console-row { display: grid; grid-template-columns: 54px 1fr 100px 72px; gap: 12px; align-items: center; padding: 16px 20px; border-bottom: 0.5px solid var(--border); font-size: 13px; }
.hyf-home .console-row.hot { box-shadow: inset 3px 0 0 #ff5a66; }
.hyf-home .console-row span { color: var(--text-faint); font-family: var(--hyf-mono); font-size: 11px; }
.hyf-home .console-row strong { color: var(--text); font-size: 13px; }
.hyf-home .console-row em { color: var(--orange-text); font-family: var(--hyf-mono); font-size: 11px; font-style: normal; text-transform: lowercase; }
.hyf-home .console-row b { color: var(--magenta); font-family: var(--hyf-mono); font-size: 11px; font-weight: 600; }
.hyf-home .console-detail { display: grid; grid-template-columns: 1fr auto; gap: 20px; padding: 20px; }
.hyf-home .console-detail span { display: block; margin-bottom: 8px; color: var(--text-faint); font-family: var(--hyf-mono); font-size: 10px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; }
.hyf-home .console-detail p { color: rgba(10, 10, 11, 0.68); font-size: 14px; line-height: 1.5; }
.hyf-home .console-score { min-width: 112px; padding: 14px; border: 0.5px solid var(--border); border-radius: 18px; background: white; }
.hyf-home .console-score strong { display: block; color: var(--text); font-size: 22px; }
.hyf-home .console-score span { margin: 4px 0 0; color: var(--text-dim); letter-spacing: 0; text-transform: none; }

.hyf-home .loop-steps { display: grid; gap: 10px; }
.hyf-home .loop-step { display: grid; grid-template-columns: 48px minmax(0, 1fr); gap: 14px; align-items: start; padding: 18px; border: 0.5px solid var(--border); border-radius: 22px; background: white; }
.hyf-home .loop-step span { grid-row: 1 / span 2; width: 38px; height: 38px; display: grid; place-items: center; border-radius: 14px; background: var(--bg-subtle); color: var(--magenta); font-family: var(--hyf-mono); font-size: 11px; font-weight: 600; }
.hyf-home .loop-step strong { grid-column: 2; display: block; margin-bottom: 4px; font-size: 18px; }
.hyf-home .loop-step p { grid-column: 2; color: rgba(10, 10, 11, 0.6); font-size: 14px; line-height: 1.5; max-width: 620px; }

/* CURATED SELECTION */
.hyf-home .selection-section { padding-top: 104px; }
.hyf-home .selection-head { display: grid; grid-template-columns: 1fr minmax(320px, 0.72fr); gap: 48px; align-items: end; }
.hyf-home .selection-head .subhead { margin-top: 0; }
.hyf-home .selection-workbench { display: grid; grid-template-columns: 0.78fr 1.22fr; gap: 18px; margin-top: 56px; }

.hyf-home .lead-ops-card { position: relative; overflow: hidden; padding: 24px; border: 0.5px solid var(--border); border-radius: 24px; background: radial-gradient(ellipse 90% 70% at 100% 0%, rgba(252, 112, 16, 0.1), transparent 56%), #fffaf6; }
.hyf-home .lead-ops-card::after { content: ""; position: absolute; right: -70px; bottom: -86px; width: 230px; height: 230px; border-radius: 999px; background: rgba(185, 30, 124, 0.08); }
.hyf-home .ops-top { position: relative; z-index: 1; display: flex; justify-content: space-between; gap: 18px; padding-bottom: 22px; border-bottom: 0.5px solid rgba(10, 10, 11, 0.08); }
.hyf-home .ops-id { display: block; margin-bottom: 12px; color: var(--text-faint); font-family: var(--hyf-mono); font-size: 11px; }
.hyf-home .ops-top h3 { margin-bottom: 3px; }
.hyf-home .ops-top p, .hyf-home .ops-message { color: rgba(10, 10, 11, 0.62); font-size: 14px; }
.hyf-home .lead-score { width: 62px; height: 62px; display: grid; place-items: center; align-content: center; border: 3px solid #ff5a66; border-radius: 50%; background: white; }
.hyf-home .lead-score strong { line-height: 1; font-size: 20px; }
.hyf-home .lead-score span { margin-top: 3px; color: var(--orange); font-family: var(--hyf-mono); font-size: 9px; font-weight: 600; }
.hyf-home .ops-message { position: relative; z-index: 1; margin: 22px 0; padding: 16px; border: 0.5px solid rgba(10, 10, 11, 0.08); border-radius: 16px; background: rgba(255, 255, 255, 0.72); line-height: 1.5; }
.hyf-home .score-breakdown { position: relative; z-index: 1; display: grid; gap: 14px; }
.hyf-home .score-breakdown div { display: grid; grid-template-columns: 1fr auto; gap: 10px; align-items: center; }
.hyf-home .score-breakdown span { color: var(--text-mid); font-size: 12px; }
.hyf-home .score-breakdown strong { color: var(--orange); font-family: var(--hyf-mono); font-size: 11px; }
.hyf-home .score-breakdown i { grid-column: 1 / -1; height: 4px; border-radius: 99px; background: linear-gradient(90deg, var(--orange), #ff5a66) 0 / var(--w) 100% no-repeat, rgba(10, 10, 11, 0.1); }
.hyf-home .ops-tags { position: relative; z-index: 1; display: flex; flex-wrap: wrap; gap: 8px; margin-top: 24px; }
.hyf-home .ops-tags span { padding: 7px 9px; border: 0.5px solid rgba(10, 10, 11, 0.08); border-radius: 99px; background: white; color: rgba(10, 10, 11, 0.62); font-size: 11px; font-weight: 500; }

.hyf-home .curated-options { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
.hyf-home .stay-option { overflow: hidden; border: 0.5px solid var(--border); border-radius: 24px; background: white; box-shadow: 0 18px 50px rgba(10, 10, 11, 0.06); }
.hyf-home .stay-option.featured { border-color: rgba(252, 112, 16, 0.36); box-shadow: 0 24px 70px rgba(252, 112, 16, 0.12); }
.hyf-home .stay-photo { min-height: 180px; background-size: cover; background-position: center; }
.hyf-home .stay-body { padding: 18px; }
.hyf-home .stay-topline, .hyf-home .stay-meta { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.hyf-home .stay-topline { justify-content: space-between; margin-bottom: 16px; }
.hyf-home .tier, .hyf-home .verified { display: inline-flex; align-items: center; padding: 6px 8px; border-radius: 99px; font-family: var(--hyf-mono); font-size: 10px; font-weight: 600; text-transform: uppercase; }
.hyf-home .tier.cheap { background: rgba(16, 185, 129, 0.12); color: #0E9F6E; }
.hyf-home .tier.mid { background: var(--orange-soft); color: var(--orange-text); }
.hyf-home .tier.premium { background: var(--magenta-soft); color: var(--magenta-text); }
.hyf-home .verified { background: var(--bg-subtle); color: var(--text-dim); }
.hyf-home .stay-body h3 { margin-bottom: 8px; font-size: 20px; }
.hyf-home .stay-body p { min-height: 66px; color: rgba(10, 10, 11, 0.6); font-size: 14px; line-height: 1.48; }
.hyf-home .stay-meta { margin-top: 16px; padding-top: 14px; border-top: 0.5px solid var(--border); }
.hyf-home .stay-meta span { color: var(--text); font-family: var(--hyf-mono); font-size: 11px; }
.hyf-home .tradeoff { margin-top: 14px; padding: 12px; border-radius: 14px; background: var(--bg-subtle); color: rgba(10, 10, 11, 0.64); font-size: 12px; line-height: 1.4; }

.hyf-home .validation-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1px; overflow: hidden; margin-top: 18px; border: 0.5px solid var(--border); border-radius: 24px; background: var(--border); }
.hyf-home .validation-item { padding: 24px; background: var(--bg); }
.hyf-home .validation-item span { display: block; margin-bottom: 36px; color: var(--magenta); font-family: var(--hyf-mono); font-size: 12px; font-weight: 600; }
.hyf-home .validation-item strong { display: block; margin-bottom: 8px; font-size: 20px; }
.hyf-home .validation-item p { color: rgba(10, 10, 11, 0.58); font-size: 14px; line-height: 1.5; }

.hyf-home .housing-types { margin-top: 18px; padding: 24px; border: 0.5px solid rgba(185, 30, 124, 0.18); border-radius: 24px; background: radial-gradient(ellipse 60% 100% at 100% 0%, rgba(185, 30, 124, 0.1), transparent 60%), var(--bg-subtle); }
.hyf-home .housing-types span { display: block; margin-bottom: 12px; color: var(--magenta); font-family: var(--hyf-mono); font-size: 11px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; }
.hyf-home .housing-types strong { display: block; margin-bottom: 8px; font-size: clamp(26px, 3vw, 40px); line-height: 1; letter-spacing: -0.04em; }
.hyf-home .housing-types p { max-width: 780px; color: rgba(10, 10, 11, 0.62); font-size: 15px; line-height: 1.55; }

/* TRUST */
.hyf-home .trust-section { padding-top: 104px; }
.hyf-home .trust-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 56px; }
.hyf-home .trust-card { min-height: 220px; padding: 22px; border: 0.5px solid var(--border); border-radius: 22px; background: white; }
.hyf-home .trust-card span { display: block; margin-bottom: 42px; color: var(--orange-text); font-family: var(--hyf-mono); font-size: 10px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; }
.hyf-home .trust-card strong { display: block; margin-bottom: 8px; font-size: 20px; line-height: 1.15; }
.hyf-home .trust-card p { color: rgba(10, 10, 11, 0.6); font-size: 14px; line-height: 1.5; }
.hyf-home .limits-note { margin-top: 14px; padding: 22px 24px; border: 0.5px solid rgba(252, 112, 16, 0.24); border-radius: 22px; background: var(--orange-soft); }
.hyf-home .limits-note strong { display: block; margin-bottom: 6px; color: var(--orange-text); }
.hyf-home .limits-note p { max-width: 900px; color: rgba(10, 10, 11, 0.68); font-size: 14px; line-height: 1.55; }

/* FINAL CTA */
.hyf-home .final-cta-block { background: var(--bg-deep); border-radius: 32px; padding: 96px 72px; margin-top: 112px; position: relative; overflow: hidden; }
.hyf-home .final-cta-block::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse 70% 60% at 90% 0%, rgba(185, 30, 124, 0.25) 0%, transparent 60%), radial-gradient(ellipse 60% 80% at 0% 100%, rgba(252, 112, 16, 0.18) 0%, transparent 60%); pointer-events: none; }
.hyf-home .final-cta-block::after { content: ''; position: absolute; inset: 0; background-image: linear-gradient(rgba(255,255,255,0.018) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.018) 1px, transparent 1px); background-size: 40px 40px; mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black 0%, transparent 100%); -webkit-mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black 0%, transparent 100%); pointer-events: none; }
.hyf-home .final-cta-block > * { position: relative; z-index: 1; }
.hyf-home .final-cta-block .h { font-family: var(--hyf-display); font-size: clamp(42px, 5.5vw, 72px); font-weight: 500; line-height: 1.0; letter-spacing: -0.045em; color: white; margin-bottom: 20px; }
.hyf-home .final-cta-block .h em { font-family: var(--hyf-serif); font-style: italic; background: linear-gradient(135deg, var(--orange-bright) 0%, var(--magenta-bright) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; font-weight: 400; }
.hyf-home .final-cta-block .sub { font-size: 18px; color: rgba(255, 255, 255, 0.65); line-height: 1.5; margin-bottom: 36px; max-width: 560px; }
.hyf-home .final-cta-block .cta-primary { background: linear-gradient(135deg, var(--orange) 0%, var(--magenta) 100%); color: white; }
.hyf-home .final-cta-block .cta-primary:hover { box-shadow: 0 12px 40px rgba(185, 30, 124, 0.45); transform: translateY(-1px); }
.hyf-home .final-cta-block .cta-meta { color: rgba(255, 255, 255, 0.45); margin-top: 28px; }

/* FINAL CTA - Home variant: multicolor background, white text, black primary button */
.hyf-home .final-cta-block.final-cta-home { background: linear-gradient(135deg, var(--orange) 0%, var(--magenta) 100%); color: #fff; }
.hyf-home .final-cta-block.final-cta-home::before { background: none; }
.hyf-home .final-cta-block.final-cta-home::after { background-image: none; }
.hyf-home .final-cta-block.final-cta-home > * { position: relative; z-index: 1; color: #fff; }
.hyf-home .final-cta-block.final-cta-home .h { color: #fff; }
/* Make the italic em text black */
.hyf-home .final-cta-block.final-cta-home .h em { background: none; -webkit-background-clip: initial; -webkit-text-fill-color: initial; background-clip: initial; color: var(--text); }
.hyf-home .final-cta-block.final-cta-home .sub { color: rgba(255,255,255,0.95); }
.hyf-home .final-cta-block.final-cta-home .cta-meta { color: rgba(255,255,255,0.85); }
/* SOPHI ONLINE pill: white background, keep green text/border */
.hyf-home .final-cta-block.final-cta-home .pill.live { background: #fff; border-color: rgba(16,185,129,0.3); color: #10B981; }
.hyf-home .final-cta-block.final-cta-home .cta-primary { background: #0A0A0B; color: #fff; border: none; box-shadow: none; }
.hyf-home .final-cta-block.final-cta-home .cta-primary:hover { background: #000; box-shadow: none; transform: none; }

@media (max-width: 768px) {
  .hyf-home .final-cta-block.final-cta-home { padding: 48px 32px; border-radius: 18px; }
}

/* FOOTER */
.hyf-home .footer { border-top: 0.5px solid var(--border); padding: 72px 32px 56px; background: var(--bg-subtle); }
.hyf-home .footer-inner { max-width: var(--max-w); margin: 0 auto; display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 48px; }
.hyf-home .footer-brand .brand { margin-bottom: 16px; }
.hyf-home .footer-brand p { font-size: 13px; color: var(--text-dim); line-height: 1.55; max-width: 300px; }
.hyf-home .footer-col h5 { font-family: var(--hyf-mono); font-size: 11px; color: var(--text-faint); letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 18px; font-weight: 500; }
.hyf-home .footer-col ul { list-style: none; display: flex; flex-direction: column; gap: 10px; padding: 0; }
.hyf-home .footer-col a { font-size: 13px; color: var(--text-mid); text-decoration: none; transition: color 0.15s; }
.hyf-home .footer-col a:hover { color: var(--text); }
.hyf-home .footer-bottom { max-width: var(--max-w); margin: 56px auto 0; padding-top: 28px; border-top: 0.5px solid var(--border); display: flex; justify-content: space-between; align-items: center; font-family: var(--hyf-mono); font-size: 11px; color: var(--text-faint); }
.hyf-home .footer-legal-links { display: flex; align-items: center; gap: 8px; }
.hyf-home .footer-legal-links a { color: var(--text-faint); text-decoration: none; transition: color 0.15s; }
.hyf-home .footer-legal-links a:hover { color: var(--text); }

/* SOCIAL ICONS — footer */
.hyf-home .footer-social { display: flex; align-items: center; gap: 10px; margin-top: 20px; }
.hyf-home .footer-social .socialcontainer { height: 40px; overflow: hidden; }
.hyf-home .footer-social .social-icon-1,
.hyf-home .footer-social .social-icon-1-1,
.hyf-home .footer-social .social-icon-2,
.hyf-home .footer-social .social-icon-2-2,
.hyf-home .footer-social .social-icon-3,
.hyf-home .footer-social .social-icon-3-3,
.hyf-home .footer-social .social-icon-4,
.hyf-home .footer-social .social-icon-4-4 { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; border-radius: 50px; }
.hyf-home .footer-social .icon svg { fill: var(--text-dim); }
.hyf-home .footer-social .social-icon-1-1 { background: transparent; }
.hyf-home .footer-social .social-icon-2-2 { background: transparent; }
.hyf-home .footer-social .social-icon-3-3 { background: transparent; }
.hyf-home .footer-social .social-icon-4-4 { background: transparent; }
.hyf-home .footer-social .social-icon-1 { background: #000; transition: transform 0.4s cubic-bezier(0.46,-0.78,0.5,1.56); }
.hyf-home .footer-social .social-icon-2 { background: linear-gradient(72.44deg,#ff7a00 11.92%,#ff0169 51.56%,#d300c5 85.69%); transition: transform 0.4s cubic-bezier(0.46,-0.78,0.5,1.56); }
.hyf-home .footer-social .social-icon-3 { background: #316ff6; transition: transform 0.4s cubic-bezier(0.46,-0.78,0.5,1.56); }
.hyf-home .footer-social .social-icon-4 { background: linear-gradient(180deg,rgba(129,34,144,1) 0%,rgba(77,34,124,1) 91%); transition: transform 0.4s cubic-bezier(0.46,-0.78,0.5,1.56); }
.hyf-home .footer-social .social-icon-1 svg,
.hyf-home .footer-social .social-icon-2 svg,
.hyf-home .footer-social .social-icon-3 svg,
.hyf-home .footer-social .social-icon-4 svg { opacity: 0; transition: opacity 0.5s 0.2s; }
.hyf-home .footer-social .socialcontainer:hover .social-icon-1 { transform: translateY(-40px); }
.hyf-home .footer-social .socialcontainer:hover .social-icon-2 { transform: translateY(-40px); }
.hyf-home .footer-social .socialcontainer:hover .social-icon-3 { transform: translateY(-40px); }
.hyf-home .footer-social .socialcontainer:hover .social-icon-4 { transform: translateY(-40px); }
.hyf-home .footer-social .socialcontainer:hover .social-icon-1 svg,
.hyf-home .footer-social .socialcontainer:hover .social-icon-2 svg,
.hyf-home .footer-social .socialcontainer:hover .social-icon-3 svg,
.hyf-home .footer-social .socialcontainer:hover .social-icon-4 svg { opacity: 1; }

.hyf-home .section-divider { max-width: var(--max-w); margin: 0 auto; height: 0.5px; background: var(--border); }

/* Reducir padding específicamente para la sección "Casos que H&F sabe resolver" */
.hyf-home #social-proof { padding-top: 24px; padding-bottom: 24px; }

.hyf-home .live-system { margin-top: 64px; }
.hyf-home .system-meta { display: flex; align-items: center; gap: 16px; margin-bottom: 28px; flex-wrap: wrap; }

/* MOBILE */
@media (max-width: 768px) {
  .hyf-home .nav-inner { padding: 14px 20px; }
  .hyf-home .nav-links { display: none; }
  .hyf-home .section, .hyf-home .section-narrow, .hyf-home .hero-section { padding: 72px 20px; }
  .hyf-home .step-item { grid-template-columns: 1fr; gap: 14px; padding: 28px 0; }
  .hyf-home .final-cta-block { padding: 48px 32px; border-radius: 18px; }
  .hyf-home .footer-inner { grid-template-columns: 1fr 1fr; gap: 32px; }
  .hyf-home .footer-brand { grid-column: span 2; }
  .hyf-home .dash-grid { grid-template-columns: 1fr; }
  .hyf-home .product-stage { padding: 16px; border-radius: 18px; }
  .hyf-home .hero-metrics { grid-template-columns: 1fr 1fr; }
  .hyf-home .selection-head,
  .hyf-home .selection-workbench,
  .hyf-home .curated-options,
  .hyf-home .validation-grid,
  .hyf-home .ops-loop-grid,
  .hyf-home .trust-grid,
  .hyf-home .pv-grid,
  .hyf-home .hero-shell { grid-template-columns: 1fr; }
  .hyf-home .console-row,
  .hyf-home .console-detail { grid-template-columns: 1fr; }
  .hyf-home .ops-console { position: static; }
  .hyf-home .stay-body p { min-height: auto; }
  .hyf-home .brand-logo { width: 38px; }
  .hyf-home .brand-logo-desktop { display: none; }
  .hyf-home .brand-logo-mobile { display: block; width: 38px; height: 38px; object-fit: contain; }
  .hyf-home .hero-section { padding-top: 84px; padding-bottom: 80px; }
  .hyf-home .sticky-cta-bar { top: 66px; padding: 8px 20px; }
  .hyf-home .sticky-cta-bar .cta { width: 100%; justify-content: center; padding: 15px 18px; font-size: 15px; box-shadow: 0 10px 28px rgba(185, 30, 124, 0.22); }
  .hyf-home .cta-row { align-items: stretch; }
  .hyf-home .cta-row .cta { justify-content: center; width: 100%; }
  .hyf-home .hero-flow-card { border-radius: 22px; }
}

/* ── SCROLL REVEAL ──────────────────────────────────────── */
.hyf-home .reveal {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1), transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}
.hyf-home .reveal.is-visible {
  opacity: 1;
  transform: translateY(0);
}
.hyf-home .reveal-d1 { transition-delay: 0.12s; }
.hyf-home .reveal-d2 { transition-delay: 0.24s; }
.hyf-home .reveal-d3 { transition-delay: 0.38s; }

/* ── NAV ACTIVE LINK ──────────────────────────────────────── */
.hyf-home .nav-links a.current { color: var(--text); font-weight: 600; }

/* ── FEATURES GRID (partners / universities / hosts) ─────── */
.hyf-home .features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-top: 56px; }
.hyf-home .feature { padding: 28px 24px; border: 0.5px solid var(--border); border-radius: 20px; background: var(--bg-subtle); transition: all 0.2s; }
.hyf-home .feature:hover { border-color: var(--orange-line); transform: translateY(-2px); box-shadow: 0 12px 32px rgba(252,112,16,0.06); }
.hyf-home .feature .tag { font-family: var(--hyf-mono); font-size: 10px; color: var(--magenta); letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 12px; }
.hyf-home .feature .name { font-family: var(--hyf-display); font-size: 18px; font-weight: 500; letter-spacing: -0.02em; margin-bottom: 8px; color: var(--text); line-height: 1.25; }
.hyf-home .feature .desc { font-size: 13px; color: var(--text-dim); line-height: 1.55; }

/* ── EYEBROW LIGHT + BODY LABEL ──────────────────────────── */
.hyf-home .eyebrow-light { font-family: var(--hyf-mono); font-size: 11px; color: var(--text-dim); text-transform: uppercase; letter-spacing: 0.06em; padding-top: 2px; }
.hyf-home .body { font-size: 15px; color: var(--text-mid); line-height: 1.6; }

/* ── HOSTS SELECTION CARDS ───────────────────────────────── */
.hyf-home .selección-card { display: grid; align-items: center; gap: 12px; padding: 12px 14px; background: var(--bg-deep-3); border: 0.5px solid var(--border-dark-2); border-radius: 10px; margin-bottom: 8px; }
.hyf-home .selección-thumb { width: 48px; height: 48px; border-radius: 8px; background: linear-gradient(135deg, var(--orange), var(--magenta)); flex-shrink: 0; }
.hyf-home .selección-thumb.t2 { background: linear-gradient(135deg, #3B82F6, #8B5CF6); }
.hyf-home .selección-thumb.t3 { background: linear-gradient(135deg, #10B981, #3B82F6); }
.hyf-home .selección-info { min-width: 0; }
.hyf-home .selección-title { font-size: 13px; color: var(--text-light); font-weight: 500; }
.hyf-home .selección-meta { font-size: 11px; color: var(--text-light-faint); margin-top: 2px; }
.hyf-home .hl-m { color: var(--magenta-bright); }

@media (max-width: 900px) {
  .hyf-home .features-grid { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
  .hyf-home .features-grid { grid-template-columns: 1fr; }
}
</style>
